import { prescriptionType, ProductCategory } from '../enum/productCategory';

export const products = [
  {
    code: 1,
    id: '8cc5dd9a-732f-45cb-bfd1-2dbdbd462719',
    tinyId: 'F10001',
    name: 'Anti-aging 10% nano VIT C',
    path: 'Anti-aging com Nano up-lift',
    showCart: true,
    hidePriceCart: false,
    oldValue: 229.90,
    value: 189.90,
    discountPercent: 15.8,
    category: ProductCategory.SKIN,
    image: '/assets/img/cart-images/anti-aging-fundo-produto.jpg',
    slug: 'anti-aging',
    numericSlug: undefined,
    rightDescription: 'Aquelas "famosas" marcas de expressão já estão começando a te incomodar?\n\nPensando nisso, desenvolvemos um anti-aging que não só reduz e previne as linhas de expressão, mas também deixa sua pele mais firme, macia e hidratada, dando a você um aspecto mais jovem e saudável. Com textura leve, é rapidamente absorvido, dando um efeito lifting no seu rosto.',
    rightDescriptionBold: 'O seu "eu" do futuro irá nos agradecer!',
    description: {
      title: 'O que é o anti-aging?',
      text: 'Um poderoso creme anti-idade que reduz os sinais de envelhecimento e diminui as linhas de expressão que surgem a partir dos 25 anos de idade.<br /><br /><strong>Com eficácia comprovada e 95% de aprovação nos testes em laboratório</strong>, nosso anti-aging corrige as marcas já existentes e previne o surgimento de novas. Fácil e prático de passar, é composto por 10% de Nano Vitamina C, Vitamina E, Ácido Hialurônico e Nano Up Lift. Juntos resultam em um produto excepcional que estimula a produção de colágeno, deixando a pele mais firme e macia, com textura uniforme e a tonalidade mais homogênea.',
    },
    rating: '4.9',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/anti-aging-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-anti-aging-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/anti-aging-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-anti-aging-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/anti-aging-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-anti-aging-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/anti-aging-1.png',
        text: 'Reduz as linhas de expressão',
      },
      {
        icon: '/assets/img/product-page-advantages/anti-aging-2.png',
        text: 'Pele firme e macia',
      },
      {
        icon: '/assets/img/product-page-advantages/anti-aging-3.png',
        text: 'Produção de colágeno',
      },
      {
        icon: '/assets/img/product-page-advantages/anti-aging-4.png',
        text: 'Aprovada no teste de eficácia',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/anti-aging.png',
      imageMobile: '/assets/img/product-page-who-uses/anti-aging-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★★',
          text: 'Nossa incrivel o cheiro! Eu uso todos os dias e é um ótimo pós barba, fica dica ai rs',
          name: 'Emílio F. - Brasília',
        },
        {
          stars: '★★★★★',
          text: 'Rejuvenesce mesmo. Uso todos os dias e mais ainda depois de pegar uma onda.',
          name: 'Victor C. - Rio de Janeiro',
        },
        {
          stars: '★★★★☆',
          text: 'Achei que após os 50 nada funcionaria, leve engano kk. Esse creme me surpreendeu e olha que já usei outros!',
          name: 'Maurício M. - São Paulo',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/anti-aging.jpg',
      bannerMobile: '/assets/img/product-page-questions/anti-aging.png',
      questions: [
        {
          name: 'O que é?',
          description: '<p>Um creme anti idade com fórmula exclusiva que rejuvenesce e hidrata a pele facial masculina</p>Composição: 10% de Nano VIT C, Ácido Hialurônico, Nano Uplift, Acácia do Senegal e Vitamina E',
        },
        {
          name: 'Como age?',
          description: 'Penetrando nas camadas mais profundas da pele facial, estimula a produção de colágeno, combate os radicais livres e promove uma hidratação completa da pele.',
        },
        {
          name: 'O que esperar?',
          description: 'Após 28 dias de uso, espera-se uma redução significativa das linhas de estresse, cansaço e expressão, o afinamento do bigode chinês e o aumento da elasticidade da pele.',
        },
      ],
    },
    productInfo: {
      type: 'PELE',
      unity: '30ml',
      duration: 'TESTE DE EFICÁCIA',
      hideUnity: true,
      hideLabel: true,
      text: [ '<p>Um surpreendente creme rejuvenescedor, que além de hidratar a pele, reduz os sinais de cansaço e linhas de estresse, bem como o bigode chinês.</p> Com <a href="https://themens-terms.s3-sa-east-1.amazonaws.com/estudo-de-eficacia-anti-aging-the-mens.pdf"  target="_blank"><u>eficácia comprovada</u></a> e 95% de aprovação nos testes em laboratório.' ],
      subText: '<a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/anti-aging.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/anti-aging-1.jpg',
        title: '95% de aprovação',
        text: 'O único creme anti idade com <u><a href="https://themens-terms.s3-sa-east-1.amazonaws.com/estudo-de-eficacia-anti-aging-the-mens.pdf" target="_blank">95% de aprovação em laboratório</a></u> após inumeros testes realizados. Os resultados são surpreendentes!'
      },
      {
        image: '/assets/img/product-page-about/anti-aging-2.jpg',
        title: 'Absorção rápida',
        text: 'Fórmula única e exclusiva que mais parece gel, ele é rapidamente absorvido e não deixa a pele oleosa. Passou, secou.'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-anti-aging-1.png',
      '/assets/img/products-images/the-mens-anti-aging-2.png',
      '/assets/img/cart-images/anti-aging-fundo-produto.jpg',
    ],
    descriptionImage: '/assets/img/products-images/the-mens-anti-aging-desc.jpg',
    amounts: [
      {
        value: 30,
        label: 'ml',
      },
    ],
    infos: {
      left: [
        {
          title: 'Nano vitamina C',
          description: 'Antioxidante que aliado a nanotecnologia,\npotencializa seus efeitos, promove uma\nação firmadora e auxilia o estímulo da\nprodução de colágeno.',
        },
        {
          title: 'Vitamina E',
          description: 'Possui efeito rejuvenescedor.\nAtua combatendo os radicais livres que\nsão os responsáveis pela formação de\nlinhas de expressão, manchas e rugas.',
        },
      ],
      right: [
        {
          title: 'Nano up lift',
          description: 'Extremamente importante para a manutenção\ne desenvolvimento da epiderme, pois atua na\nprodução de colágeno e queratina.\n\n',
        },
        {
          title: 'Ácido hialurônico',
          description: 'Ajuda a manter a hidratação e sustentação da pele,\nevitando a flacidez. Promove uma intensa\nrevitalização, reduzindo as linhas de expressão e\ndeixando a pele mais hidratada e macia.',
        },
      ],
    },
    faq: [
      {
        title: 'Como devo usar?',
        description: 'Com a pele limpa, aplique o Anti-aging da The Men\'s massageando até ser totalmente absorvido. Sugestão: use logo após o banho.\n',
      },
      {
        title: 'Devo utilizar protetor solar após aplicar o anti-aging?',
        description: 'Para uma pele mais jovem e saudável recomendamos o uso de protetor solar, pois ajudará a protegê-la da exposição ao sol.',
      },
      {
        title: 'Tem efeito em todos os tipos de pele?',
        description: 'Sim. Se usado de forma correta e seguindo todas as indicações, o resultado do tratamento terá o mesmo efeito em todas as peles.',
      },
      {
        title: 'Quantas vezes ao dia devo passar?',
        description: 'Recomenda-se utilizar 2 pumps ao dia. O segredo para uma pele jovem é o uso contínuo do produto.',
      },
      {
        title: 'Onde encontro o teste de eficácia?',
        description: 'Nosso teste de eficácia pode ser encontrado <a href="https://themens-terms.s3-sa-east-1.amazonaws.com/estudo-de-eficacia-anti-aging-the-mens.pdf" target="_blank" rel="noreferrer noopener">aqui</a>.',
      },
      {
        title: 'Em quanto tempo irei perceber os resultados?',
        description: 'Logo nos primeiros dias você perceberá sua pele mais jovem, hidratada e macia. Dentro de 28 dias, resultados mais intensos já são notados por nossos usuários.',
      },
      {
        title: 'Qual PH do Anti-Aging da The Men\'s?',
        description: 'Nosso produto tem PH entre 3.0 - 4.0.',
      },
      {
        title: 'É fácil de utilizar ? Deixa a pele oleosa?',
        description: 'Sim, é fácil de passar e espalhar. Em nossos testes, 95% dos participantes afirmaram que foi fácil de aplicar e espalhar o produto sobre a pele; 90% afirmaram que o produto foi absorvido rapidamente pela pele (secou rápido) e que não deixou a pele oleosa.',
      },
    ],
  },
  {
    code: 2,
    id: '3b445d33-0849-4976-aa07-11cc61770141',
    tinyId: 'F10002',
    name: 'Chá Daily Boost',
    path: 'Chá Energizante',
    value: 68.9,
    showCart: true,
    hidePriceCart: false,
    oldValue: 88.9,
    category: ProductCategory.HEALTH,
    image: '/assets/img/cart-images/daily-boost-fundo-produto.jpg',
    slug: 'cha-do-dia-fora-de-estoque',
    numericSlug: undefined,
    rating: '5.0',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/cha-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-cha-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/cha-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-cha-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/cha-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-cha-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/cha-1.png',
        text: '4x mais fortes que outras',
      },
      {
        icon: '/assets/img/product-page-advantages/cha-2.png',
        text: 'Crescimento capilar',
      },
      {
        icon: '/assets/img/product-page-advantages/cha-3.png',
        text: 'Zero açúcar',
      },
      {
        icon: '/assets/img/product-page-advantages/cha-4.png',
        text: 'Fortacele a imunidade',
      },
      {
        icon: '/assets/img/product-page-advantages/cha-5.png',
        text: 'Fortacele a imunidade',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/cha.png',
      imageMobile: '/assets/img/product-page-who-uses/cha-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★★',
          text: 'Realmente um produto diferenciado. Tomei e senti um calor logo em seguida, tenho muito mais energia.',
          name: 'Carlos B. - São Paulo',
        },
        {
          stars: '★★★★★',
          text: 'Substituí pelo café antes dos meus treinos. Estou gostando bastante do resultado',
          name: 'Cesar C. - Porto Alegre',
        },
        {
          stars: '★★★★☆',
          text: 'Tem ação diurética forte, volto do fds inchado, tomo ele e pronto! Além disso, cura ressaca kkkk',
          name: 'Lucas H. - Rio de Janeiro',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/cha.png',
      bannerMobile: '/assets/img/product-page-questions/cha-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: 'Uma bebida leve e prática composta por 12 ervas pré-selecionadas. Não contém glúten e nem açúcar.',
        },
        {
          name: 'Como age?',
          description: 'Ao ingerir o Chá Daily Boost, nosso corpo absorve os nutrientes presentes nas ervas, contribuindo para o aumento da diurese e da saciedade, além de auxiliar no gasto calórico.',
        },
        {
          name: 'O que esperar?',
          description: 'As ervas pré selecionadas podem auxiliar no aumento do estado de atenção e na melhora da concentração.',
        },
      ],
    },
    productInfo: {
      type: 'QUEDA DE CABELO',
      unity: '30unid',
      duration: '1 MÊS',
      hideUnity: true,
      hideLabel: false,
      text: [ 'Ervas de verdade, sem perder nutrientes. Desenvolvida por um time de especialistas em performance corporal. Uma bebida leve e gostosa, que pode trazer benefícios para concentração e foco.' ],
      subText: '<a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/cha.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/cha-1.jpg',
        title: 'Alto Rendimento',
        text: 'Utilizado e recomendado por atletas de alta performance que dependiam do café para ter mais energia. '
      },
      {
        image: '/assets/img/product-page-about/cha-2.jpg',
        title: 'Foco e Energia',
        text: 'Substitua seu café pelo nosso delicioso chá. Ele é feito a partir de ingredientes naturais que te ajudam a ter disposição para o seu dia.'
      },
      {
        image: '/assets/img/product-page-about/cha-3.jpg',
        title: 'Inchaço',
        text: 'Exagerou no final de semana? Essa bebida é feita a partir de ingredientes naturais que podem auxiliar na diurese e no combate a retenção de líquidos.'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-cha-1.png',
      '/assets/img/products-images/the-mens-cha-2.png',
      '/assets/img/cart-images/daily-boost-fundo-produto.jpg',
    ],
    rightDescription: '<strong>DAILY BOOST</strong>\nSelecionamos as melhores ervas para criarmos uma bebida única, leve e saudável. Tenha mais energia a qualquer hora do dia sem manchar os dentes.',
    rightDescriptionBold: 'Dê um up no seu dia!',
    description: {
      title: 'O que é chá do dia | Daily boost?',
      text: 'É uma bebida estimulante, que te dá energia e te ajuda a secar. Desenvolvida por um time de especialistas, as ervas foram selecionadas cuidadosamente até encontrarmos uma bebida leve, gostosa e energizante.<br /><br />Nossa fórmula, perfeita, contém um misto de mate verde, chá verde, carqueja, hibisco, chá preto e guaraná com canela, gengibre, alecrim, sálvia, cravo e pimenta preta, com leve aroma de abacaxi.<br /><br /><strong>Experimente e surpreenda-se!</strong>',
    },

    descriptionImage: '/assets/img/products-images/the-mens-cha-desc.jpg',
    amounts: [
      {
        value: 60,
        label: 'sachês',
      },
    ],
    infos: {
      left: [
        {
          title: 'Mate Verde',
          description: 'Acelera o metabolismo, proporcionando\nmaior energia e foco. Possui efeito\ndiurético auxiliando na perda de peso.\n\n',
        },
        {
          title: 'Hibisco',
          description: 'Um anti-inflamatório e antioxidante que\ncontribuí para que menos gordura fique\nacumulada na região do abdômen e evita\na retenção de líquidos.',
        },
        {
          title: 'Gengibre',
          description: 'Rico em substâncias termogênicas que\npotencializam a queima de gordura corporal e\najudam a ter mais foco e energia.',
        },
      ],
      right: [
        {
          title: 'Chá Preto',
          description: 'Estimulante que garante energia, diminuição do\ncansaço e da sonolência ao longo do dia.\nAuxilia na queima de gordura e na redução do\napetite devido às substâncias antioxidantes.',
        },
        {
          title: 'Guaraná',
          description: 'Energizante que auxilia na circulação sanguínea,\npropiciando um maior rendimento e disposição.\nTambém ajuda a eliminar toxinas do organismo\ndevido às propriedades diuréticas.',
        },
        {
          title: 'Pimenta Preta',
          description: 'Com ação termogênica, estimula a produção de\nserotonina, aumentando a sensação de \nbem-estar e melhora na produtividade.',
        },
      ],
    },
    faq: [
      {
        title: 'Qual o modo de preparo? ',
        description: 'Para preparar seu chá, basta seguir as devidas instruções:\n1) Esquente 200ml de água até começar a ferver e desligue o fogo.\n2) Coloque um sachê dentro da água, tampe e espere 3 minutos.\n3) Pronto! Seu chá energizante está pronto para beber.\n\nDica apimentada: Sempre fica um pouco de pozinho no envelope de cada sachê.\nAdicione-o no seu chá e surpreenda-se com o resultado.',
      },
      {
        title: 'Quais os ingredientes?',
        description: 'Com ingredientes cuidadosamente selecionados e um mix variado, nosso chá leva em sua composição: mate verde, chá verde, carqueja, hibisco, chá preto e guaraná com canela, gengibre, alecrim, sálvia, cravo e pimenta preta.',
      },
      {
        title: 'Quantos sachês vêm dentro da caixa? ',
        description: 'Nossa caixa é acompanhada de 60 sachês, sugere-se o uso de 2 sachês ao dia.',
      },
      {
        title: 'Somente homens podem tomar?',
        description: 'Não. Qualquer pessoa pode tomar, independente do sexo biológico.',
      },
      {
        title: 'Posso tomar todos os dias?',
        description: 'Sim, não há contraindicações. Tome à vontade e tenha energia durante todo o seu dia, ou à noite rsrs.',
      },
      {
        title: 'Posso tomar antes de dormir?',
        description: 'Caso vá dormir logo em seguida, não é recomendado sua ingestão, devido às suas propriedades estimulantes.',
      },
      {
        title: 'Posso tomar gelado?',
        description: 'Pode! Contudo, dada às propriedades termogênicas, recomendamos seu uso quente e logo após a infusão.',
      },
      {
        title: 'Posso misturar com outras bebidas?',
        description: 'Não há contraindicações para criar um drink especial. Deu certo? Não deixe de nos contar nas redes sociais.',
      },
    ],
  },
  {
    code: 3,
    id: 'fbd7397f-8071-4f0a-9a64-90debfbf908a',
    tinyId: 'F10008',
    name: 'Tônico para barba',
    path: 'Tônico com Auxina Tricógena®',
    showCart: true,
    hidePriceCart: false,
    value: 64.9,
    oldValue: 84.9,
    discountPercent: 22,
    category: ProductCategory.BEARD,
    image: '/assets/img/cart-images/tonico-fundo-produto.jpg',
    slug: 'tonico-para-barba',
    numericSlug: undefined,
    rating: '4.7',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/tonico-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-tonico-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/tonico-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-tonico-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/tonico-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-tonico-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/tonico-1.png',
        text: '4x mais fortes que outras',
      },
      {
        icon: '/assets/img/product-page-advantages/tonico-2.png',
        text: 'Crescimento capilar',
      },
      {
        icon: '/assets/img/product-page-advantages/tonico-3.png',
        text: 'Zero açúcar',
      },
      {
        icon: '/assets/img/product-page-advantages/tonico-4.png',
        text: 'Fortacele a imunidade',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/tonico.png',
      imageMobile: '/assets/img/product-page-who-uses/tonico-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★★',
          text: 'Aonde já se viu japonês com barba? Achei que nunca ia ter até usar o tônico!',
          name: 'Rodrigo G. - São Paulo',
        },
        {
          stars: '★★★★★',
          text: 'Muito cheiroso e gostoso de passar. Super recomendo!',
          name: 'Cesar Cielo - Santa Catarina',
        },
        {
          stars: '★★★★☆',
          text: 'Não acreditava mas após 5 meses de uso estou super barbudo e confiante!',
          name: 'Glauco R. - São Paulo',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/tonico.jpg',
      bannerMobile: '/assets/img/product-page-questions/tonico-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: '<p>Um blend de poderosos ativos, com tecnologia patenteada e comprovação científica para estimular o crescimento da barba e acelerar a formação de novos fios.</p> Composição: 15% de Auxina Tricógena, H-VIT©, Biotina, mentol, Arginina e Fito extratos tonificantes.',
        },
        {
          name: 'Como age?',
          description: 'Atingindo as camadas mais profundas da pele do rosto, aumenta a circulação sanguínea, propiciando que mais nutrientes cheguem ao local. Ainda, estimula as células capilares para que você tenha um crescimento mais rápido e duradouro da barba.',
        },
        {
          name: 'O que esperar?',
          description: '<p>Ao longo dos meses* de utilização diária, espera-se uma significativa redução da oleosidade, um aumento relevante da densidade e quantidade dos fios e o fechamento das falhas na barba</p> *Recomenda-se o uso por no mínimo 3 meses consecutivos',
        },
        {
          name: 'Composição (Português)?',
          description: 'Água, Álcool, Estearato de Glicerila, Cetearete-20, Polisorbato 20, Poliacrilamida, Propilenoglicol, C13-14 Isoparaffin, Hidroxietilcelulose, Extrato do Córtex de Quina Vermelha, Extrato de Aquiléia Mil-Folhas (Achillea Millefolium), Extrato da Flor de Tussilagem, Perfume, Trolamina, Dimetilidantoína, Glicerol, Laurete-7, Extrato de Rosa, Mentol, Extrato de Rizoma/Raiz de Alcaçuz, Extrato da Folha de Chicória, Extrato de Rhodophyceae Hidrolisado, Pantenol, Benzotriazolil Dodecil P-Cresol, Extrato da Casca de Romã, Ácido Linoleico, Extrato da Semente de Guaraná, Extrato da Raiz de Gengibre, Ácido Pidólico, Lactato de Sódio, Linalol, Extrato da Semente de Café, Extrato da Folha de Jaborandi, Extrato da Folha de Confrei, Butilcarbamato de Iodopropinila, Arginina, Ácido Aspártico, Xilitol, Ácido Pidólico, Geraniol, Ácido Caprílico, Edetato Dissódico, Caprililglicol, Glicina, Alanina, Hexil Cinamal, Isoleucina, Serina, Valina, Biotina, Treonina, Prolina, Histidina, Fenilalanina.',
        },
      ],
    },
    productInfo: {
      type: 'QUEDA DE CABELO',
      unity: '30unid',
      duration: '1 MÊS',
      hideUnity: true,
      hideLabel: false,
      text: [ '<p>Um tônico com alta tecnologia para você fechar as falhas e ter mais barba.</p> O único com 15% de Auxina Tricógena© e H-VIT©, mais forte e efeito eterno Aprovado pela Anvisa.' ],

      subText: '<a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/tonico.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/tonico-1.jpg',
        title: 'Eficácia comprovada',
        text: 'Com tecnologia patenteada e testes clínicos realizados em laboratórios verificou-se um nítidos crescimento dos fios e um fechamento das falhas.'
      },
      {
        image: '/assets/img/product-page-about/tonico-2.jpg',
        title: 'Resultados eternos',
        text: 'Após o alcance dos resultados obtidos, não é necessário utilizar mais o tônico, pois sua barba continuara crescendo.'
      },
      {
        image: '/assets/img/product-page-about/tonico-3.jpg',
        title: 'Absorção mais rápida',
        text: 'Com uma fórmula exclusiva feita para ser rapidamente absorvida e dimunuir a oleosidade, nosso tônico entrega resultados surpreendentes sem deixar a pele oleosa.'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-tonico-para-barba-1.png',
      '/assets/img/products-images/the-mens-tonico-para-barba-2.png',
      '/assets/img/cart-images/tonico-fundo-produto.jpg',
    ],
    rightDescription: 'Já pode separar seu barbeador porque com o nosso Tônico você vai usar ele mais vezes do que imagina!<br /><br />Desenvolvido para estimular o crescimento saudável dos fios e auxiliar a combater a queda. Tenha mais volume e feche as falhas.<br /><br /><strong>Sua barba vai crescer como nunca cresceu!</strong>',
    description: {
      title: 'O que é o tônico para a barba?',
      text: 'É um blend de ativos que auxiliam no crescimento da barba, aumentando o volume e fechando as falhas.<br /><br />Com uma composição rica de aminoácidos e vitaminas, promove o crescimento acelerado do pelo, gera uma ação protetora e controla a oleosidade excessiva. Seus ativos irão preencher sua barba e aumentar o volume, além de deixar os fios mais brilhosos e saudáveis. Livre de parabenos.',
    },
    descriptionImage: '/assets/img/products-images/the-mens-tonico-para-barba-desc-new.jpg',
    amounts: [
      {
        value: 30,
        label: 'ml',
      },
    ],
    infos: {
      left: [
        {
          title: 'Auxina Tricogena ®',
          description: 'Com eficácia comprovada, auxilia no crescimento\ne fortalecimento dos fios. Age melhorando o\ntrofismo do pelo na fase anágena ao mesmo\ntempo em que diminui a fase telógena.',
        },
        {
          title: 'Biotina',
          description: 'Auxilia na formação de queratina, protegendo\na estrutura da haste dos pelos. Além disso,\nmantém a região hidratada e ajuda\nno crescimento saudável dos fios.',
        },
        {
          title: 'Mentol',
          description: 'Com ação refrescante, auxilia o crescimento\nda barba, reduz o excesso de oleosidade da\npele e evita a queda dos pelos.',
        },
      ],
      right: [
        {
          title: 'H-Vit ®',
          description: 'Ativo multifuncional que controla a oleosidade\ndo local onde foi utilizado. Além disso,\npromove a restauração da barreira cutânea e\nfortalece o bulbo, auxiliando na prevenção da queda.',
        },
        {
          title: 'Fito extratos tonificantes',
          description: 'Promove ações tonificantes, antisséptica,\ncicatrizante, protetora, hidratante, regeneradora e\natravés dos derivados da celulose.\n\n',
        },
        {
          title: 'Arginina',
          description: 'Aminoácido essencial que compõe a fibra capilar.\nPromove o crescimento dos fios e cria uma película\nque fecha as escamas dos pelos, fortalecendo-os e\ndiminuindo a queda e a quebra.',
        },
      ],
    },
    faq: [
      {
        title: 'Como devo utilizá-lo?',
        description: 'Agite antes de usar. Sobre a pele limpa, aplique uma pequena quantidade com a ponta dos dedos massageando bem sobre a pele até sua absorção. Deixe secar naturalmente.',
      },
      {
        title: 'Quantas vezes ao dia devo passar?',
        description: 'Para resultados mais intensos, recomenda-se o uso 2x ao dia. Não lave o local de aplicação por 3h. ',
      },
      {
        title: 'Pode ser usado em todos os tipos de pele? ',
        description: 'Sim! Nosso tônico pode ser utilizado em todos os tipos de pele.',
      },
      {
        title: 'Em quanto tempo vejo o resultado?',
        description: 'A partir do 2º mês, você já começa a perceber uma barba um pouco mais volumosa e as falhas diminuindo. Contudo, a partir do 3º mês, os resultados são mais notórios.',
      },
      {
        title: 'Posso usar todos os dias?',
        description: 'Deve. O uso diário é essencial para um tratamento adequado e satisfatório. ',
      },
      {
        title: 'Engrossa meu pelo? ',
        description: 'Sim, com o uso do tônico, os pelos ralos e frágeis serão fortalecidos.',
      },
    ],
  },
  {
    code: 4,
    id: '2ad58d0e-5934-4f1a-9d51-8cba378122b6',
    tinyId: 'F10005',
    name: 'Vita gummy',
    path: 'Vita gummy',
    value: 66.3,
    showCart: true,
    hidePriceCart: false,
    oldValue: 89.9,
    category: ProductCategory.HAIR,
    image: '/assets/img/cart-images/nova-vita-gummy-fundo-produto.jpg',
    slug: 'gummy',
    numericSlug: undefined,
    rating: '4.9',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/gummy-1.png',
        mini: '/assets/img/product-page-carousel/mini-gummy-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/gummy-2.png',
        mini: '/assets/img/product-page-carousel/mini-gummy-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/gummy-3.png',
        mini: '/assets/img/product-page-carousel/mini-gummy-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/gummy-1.png',
        text: '4x mais fortes que outras',
      },
      {
        icon: '/assets/img/product-page-advantages/gummy-2.png',
        text: 'Crescimento capilar',
      },
      {
        icon: '/assets/img/product-page-advantages/gummy-3.png',
        text: 'Zero açúcar',
      },
      {
        icon: '/assets/img/product-page-advantages/gummy-4.png',
        text: 'Fortacele a imunidade',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/gummy.png',
      imageMobile: '/assets/img/product-page-who-uses/gummy-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★★',
          text: 'Sinto meus cabelos mais fortes e volumosos. Dificil é comer só uma gummy',
          name: 'Tiago N. - São Paulo',
        },
        {
          stars: '★★★★★',
          text: 'Junto com o tônico, acelerou demais o crescimento da minha barba',
          name: 'Rodrigo I. - São Paulo',
        },
        {
          stars: '★★★★★',
          text: 'O melhor polivitaminico que eu já tomei!!',
          name: 'Gorgonoid. - Minas Gerais',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/gummy.png',
      bannerMobile: '/assets/img/product-page-questions/gummy-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: '<p>Bala de gelatina com 11 nutrientes necessários para seu cabelo crescer mais rápido e mais forte.</p> Composição: Vitamina A (1.200mcg), Vitamina B5 (5mg), Biotina (45mcg), Vitamina B9 (667mcg), Vitamina B12 (8mcg), Vitamina C (60mg), Vitamina D (19mcg), Vitamina E (10mg), Iodo (80mcg) e Zinco (7mg)',
        },
        {
          name: 'Como age?',
          description: 'Suprindo todas as necessidades diárias de vitaminas e minerais para que o crescimento e fortalecimento do cabelo se dê em sua máxima performance.',
        },
        {
          name: 'O que esperar?',
          description: 'Uma suplementação completa de vitaminas e minerais que te auxilia a ter um crescimento capilar (cabelo e barba) mais rápido e saudavel e uma imunidade mais forte.',
        },
      ],
    },
    productInfo: {
      type: 'QUEDA DE CABELO',
      unity: '30unid',
      duration: '1 MÊS',
      hideUnity: true,
      hideLabel: false,
      text: [ 'Nossa vita gummy contém todos os nutrientes e vitaminas que você precisa para ter mais vitalidade, mais cabelos e imunidade.' ],
      subText: '<a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/gummy.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/gummy-1.png',
        title: 'Composição perfeita',
        text: 'Boost de nutrientes e minerais especialmente calculados e selecionados para um efeito 4x mais forte e prolongado'
      },
      {
        image: '/assets/img/product-page-about/gummy-2.png',
        title: 'Zero açúcar',
        text: 'Pensando na sua saúde, desenvolvemos uma gelatina que não contenha açúcar, não afetando sua dieta e promovendo uma qualidade de vida'
      },
      {
        image: '/assets/img/product-page-about/gummy-3.png',
        title: 'Deliciosa',
        text: 'Com um sabor gostoso, você se nutre sem perceber. Dificil será comer somente uma hmm...'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-gummy-1.png',
      '/assets/img/products-images/vita-gummy.png',
      '/assets/img/cart-images/nova-vita-gummy-fundo-produto.jpg',
    ],
    rightDescription: 'Desenvolvida especialmente para você, com um delicioso sabor de maçã verde e zero açúcar. Nossa vita gummy contém todos os nutrientes necessários para fortalecer seu cabelo, pele e unhas. <strong>Duvido comer só uma!</strong>',
    description: {
      title: 'O que é a vitma gummy?',
      text: 'Nossa vita gummy é um suplemento alimentar, feito à base de gelatina, com nutrientes essenciais para o crescimento capilar. Zero açúcar, contêm em sua formulação um alto teor de B7 (Biotina), B9 (Ácido fólico), B5 (Ácido Pantotênico) vitaminas A, B12, C, D, zinco entre outras. Ela previne a queda capilar e a calvície, além de auxiliar no funcionamento do sistema imune.',
    },
    descriptionImage: '/assets/img/products-images/the-mens-gummy-desc.jpg',
    amounts: [
      {
        value: 105,
        label: 'g',
      },
      {
        value: 30,
        label: 'unidades',
      },
    ],
    infos: {
      left: [
        {
          title: 'Biotina',
          description: 'Essencial para a saúde dos cabelos,\npele, unhas, contríbui na produção\nde queratina pelo corpo humano.',
        },
        {
          title: 'Ácido Fólico',
          description: 'Estimula o crescimento dos cabelos e\ndas unhas, controla a oleosidade e\ncombate a acne e a dermatite, deixando\no cabelo com mais brilho.',
        },
        {
          title: 'Zinco',
          description: 'Reduz a queda de cabelo,\nauxilia no tratamento da acne e\nna cicatrização de feridas.',
        },
      ],
      right: [
        {
          title: 'Vitamina A',
          description: 'Extremamente importante para a manutenção e\ndesenvolvimento do tecido capilar, pois atua na\nprodução de colágeno e queratina.',
        },
        {
          title: 'Vitamina C',
          description: 'É um poderoso antioxidante, que auxilia na formação\nde colágeno e protege os fios, deixando as hastes\ncapilares mais fortes; e previne a descamação e\nirritação do couro cabeludo.',
        },
        {
          title: 'Vitamina D',
          description: 'Ajuda na recuperação de estrutura capilar\ne no funcionamento muscular e é\nessencial para o nosso sistema imune.',
        },
      ],
    },
    faq: [
      {
        title: 'Do que é feita a vita gummy?',
        description: 'Um produto saboroso, zero açúcar, feito à base de gelatina e pectina vegetal cheio de vitaminas. As gummies contêm B7 (Biotina), B9 (Ácido fólico), B5 (Ácido Pantotênico) vitaminas A, B12, C, D, zinco e Iodo.',
      },
      {
        title: 'Quantas gummies posso comer por dia?',
        description: 'É indicado consumir  apenas uma vita gummy ao dia ou conforme orientação médica.',
      },
      {
        title: 'Existe alguma contraindicação?',
        description: 'Nossa vita gummy é contraindicada para gestantes, lactantes e crianças.',
      },
      {
        title: 'A vita gummy engorda?',
        description: 'Acredite, você queima 1 vita gummy com apenas um copo de água gelada.',
      },
      {
        title: 'A vita gummy é indicada para todos os tipos de cabelo?',
        description: 'Sim, as vitaminas funcionam para todos os tipos de cabelo, agindo de dentro para fora dos fios.',
      },
      {
        title: 'Quando vou ver os resultados?',
        description: 'Para que o tratamento seja eficaz, recomendamos o uso de nossas gummies por 3 meses, porém os resultados variam de acordo com o estilo de vida e metabolismo de cada pessoa. Para um melhor resultado, recomendamos nosso hair kit.',
      },
    ],
  },
  {
    code: 5,
    id: 'e6c99cac-19cf-4f18-8704-0fff17dbb133',
    tinyId: 'F10007',
    name: 'Shampoo Energizante',
    path: 'Shampoo com H-Vit®',
    value: 44.9,
    showCart: true,
    hidePriceCart: false,
    oldValue: 69.9,
    subscriptionDiscount: 20,
    category: ProductCategory.HAIR,
    image: '/assets/img/cart-images/shampoo-fundo-produto.jpg',
    slug: 'shampoo-energizante',
    numericSlug: undefined,
    rating: '4.7',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/shampoo-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-shampoo-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/shampoo-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-shampoo-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/shampoo-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-shampoo-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/shampoo-1.png',
        text: 'Limpeza profunda',
      },
      {
        icon: '/assets/img/product-page-advantages/shampoo-2.png',
        text: 'Mais brilho e volume',
      },
      {
        icon: '/assets/img/product-page-advantages/shampoo-3.png',
        text: 'Fortalece os fios fracos',
      },
      {
        icon: '/assets/img/product-page-advantages/shampoo-4.png',
        text: 'Combate a caspa',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/shampoo.png',
      imageMobile: '/assets/img/product-page-who-uses/shampoo-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★☆',
          text: 'Meus fios eram quebradiços e fracos e agora, depois de 1 mês sinto eles muito mais forte!',
          name: 'Thiago C. - Rio Grande do Norte',
        },
        {
          stars: '★★★★★',
          text: 'Impressionante! Minha caspa acabou ',
          name: 'Carlos W. - Porto Alegre',
        },
        {
          stars: '★★★★☆',
          text: 'Cheiroso, gostoso e limpa mesmo o couro cabeludo! Não fica com aspecto de ressecado!!',
          name: 'João A. - São Paulo',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/shampoo.jpg',
      bannerMobile: '/assets/img/product-page-questions/shampoo-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: 'Um shampoo desenvolvido para limpar profundamente o couro cabeludo, gerando um ambiente asséptico, antibactericida e antifungicida: propício para que os nutrientes contidos em sua formulação penetrem com maior facilidade na cabeça, além de deixar um ambiente pronto para receber outro ativos.',
        },
        {
          name: 'Como age?',
          description: 'Atingindo as camadas mais profundas do couro cabeludo, nossa fórmula com H-Vit, Biotina, Pantenol, Café, Jaborandi e outros componentes tonificam os fios e controlam a oleosidade, revitalizando e fortalecendo os fios fracos e quebradiços. Tudo isso com um cheiro gostoso e refrescante.',
        },
        {
          name: 'O que esperar?',
          description: 'Quem utiliza o shampoo, deve esperar a diminuição da oleosidade, a redução da caspa e um cabelo macio e volumoso.',
        },
        {
          name: 'Composição (Português)?',
          description: 'Água, Lauriletersulfato de Sódio, Dietanolamina Cocamida, Copolímero de Ácido Metacrílico e Acrilato de Etila, Cocamidopropil Betaína, Estearamidopropil Dimetilamina, Perfume, Mentol, Poliquatérnio-7, Abietoil Proteína de Soja Hidrolisada Potássio, Edetato Dissódico, Dimetilidantoína, Ácido Cítrico, Glicerol, PEG-90M, Cloreto de Guar Hidroxipropiltrimônio, Extrato de Rosa, Benzotriazolil Dodecil P-Cresol, Extrato de Rizoma/Raiz de Alcaçuz, Extrato da Folha de Chicória, Extrato de Rhodophyceae Hidrolisado, Extrato da Casca de Romã, Pantenol, Extrato da Semente de Guaraná, Extrato da Raiz de Gengibre, Linalol, Ácido Linoleico, Extrato da Folha de Jaborandi, Extrato de Confrei, Extrato de Semente de Café, Cloreto de Amônio, Butilcarbamato de Iodopropinila, Ácido Fumárico, Xilitol, Ácido Caprílico, Caprililglicol, Hidróxido de Sódio, Biotina.',
        },
      ],
    },
    productInfo: {
      type: 'QUEDA DE CABELO',
      unity: '200ml',
      duration: '1 MÊS',
      hideUnity: true,
      hideLabel: false,
      text: [ 'Cheiroso e cheio de nutrientes, nosso shampoo contém ativos que ajudam a revitalizar e fortalecer os fios fracos e quebradiços, além de limpar profundamente o couro cabeludo, garantindo a melhor absorção dos nutrientes.' ],
      subText: '<p>Indicado para todos os tipos de cabelo.</p><p><a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a></p>',
      img: '/assets/img/product-page-info/shampoo.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/shampoo-1.png',
        title: 'Alto rendimento',
        text: 'Com a viscocidade perfeita, uma pequena porção já é suficiente para limpar o seu couro cabeludo e fortalece os fios'
      },
      {
        image: '/assets/img/product-page-about/shampoo-2.png',
        title: 'Comprovação clínica',
        text: 'Testes realizados em laboratório comprovaram uma diminuição significativa da oleosidade em 28 dias de uso, reduzindo assim a caspa e propiciando um ambiente favorável ao crescimento capilar'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-shampoo-energizante-1.png',
      '/assets/img/products-images/the-mens-shampoo-energizante-2.png',
      '/assets/img/cart-images/shampoo-fundo-produto.jpg',
    ],
    rightDescription: 'Cheiroso e cheio de nutrientes, nosso shampoo contém ativos que ajudam a revitalizar e fortalecer os fios fracos e quebradiços, além de limpar profundamente o couro cabeludo, garantindo a melhor absorção dos nutrientes.<br /><br />Indicado para <strong>todos os tipos de cabelo.</strong>',
    description: {
      title: 'O que é o shampoo energizante?',
      text: 'Um shampoo desenvolvido para limpar profundamente o couro cabeludo, gerando um ambiente asséptico, antibactericida e antifungicida: propício para que os nutrientes contidos em sua formulação, penetrem com maior facilidade na cabeça, além de deixar um ambiente pronto para receber outro ativos.<br/><br/>Nossa fórmula com H-Vit, Biotina, Pantenol, Café, Jaborandi e outros componentes é ideal para tonificar os fios e controlar a oleosidade, ajudando também a revitalizar e fortalecer os fios fracos e quebradiços, ainda, com um cheiro gostoso, limpa e refresca o couro cabeludo.<br/><br/>Livre de sulfatos, sal (cloreto de sódio) e parabenos.',
    },
    descriptionImage: '/assets/img/products-images/the-mens-shampoo-energizante-desc.jpg',
    amounts: [
      {
        value: 200,
        label: 'ml',
      },
    ],
    infos: {
      left: [
        {
          title: 'Biotina',
          description: 'Auxilia na formação de queratina.\nAlém disso, mantém o couro cabeludo,\nhidratado, ajuda no crescimento saudável\ndos fios e no combate a caspa.',
        },
        {
          title: 'Pantenol',
          description: 'Ativa o ácido pantotênico, essencial para\nrepor os níveis de proteína e lipídios do\ncouro cabeludo. Proporcionando brilho e\nhidratação para os fios.',
        },
        {
          title: 'Extrato de Jaborandi',
          description: 'Princípio ativo que proporciona ação adstringente,\npromove a limpeza profunda do couro cabeludo,\ncombatendo a oleosidade e a seborreia.',
        },
      ],
      right: [
        {
          title: 'H-Vit ®',
          description: 'Super complexo multivitamínico que controla a\noleosidade da pele e couro cabeludo, promove\nrestauração da barreira cutânea, fortalece o bulbo\ncapilar, auxiliando na prevenção da queda.',
        },
        {
          title: 'Abietoil',
          description: 'Um tensoativo vegetal de alta afinidade\ncom a pele e cabelos. Promove a redução\nda oleosidade, reequilibrando a função\nsebácea sem ressecar os fios.',
        },
        {
          title: 'Fios extratos tonificantes',
          description: 'Ações estimulantes, tonificantes, antisséptica,\ncicatrizante, protetora, hidratante, regeneradora\ne anti-inflamatória. Dando maciez aos cabelos\natravés dos derivados de celulose.',
        },
      ],
    },
    faq: [
      {
        title: 'Posso usar todos os dias?',
        description: 'Nosso Shampoo deve ser usado, ao menos, uma vez ao dia.',
      },
      {
        title: 'Tenho o couro cabeludo muito sensível, posso usar o Shampoo energizante?',
        description: 'Sim, nosso shampoo é dermatologicamente testado.',
      },
      {
        title: 'Se eu usar apenas 1 mês vai ter efeito?',
        description: 'Para que o tratamento seja eficaz, recomendamos o uso de nosso shampoo energizante por pelo menos 3 meses, porém os resultados variam de acordo com cada pessoa. Para um melhor resultado, conheça nosso hair kit.',
      },
      {
        title: 'Como devo usar esse shampoo?',
        description: 'Tire a roupa, entre no chuveiro, molhe os cabelos  e aplique uma quantidade pequena do shampoo sobre as mãos. Leve-as ao couro cabeludo e massageie-o até formar uma espuma rica e cheirosa. Enxágue e repita o processo.',
      },
      {
        title: 'Ele resseca os cabelos?',
        description: 'Não. Nosso shampoo foi desenvolvido para limpar profundamente o couro cabeludo e os fios, mas sem ressecá-los e gerar pontas duplas.',
      },
      {
        title: 'Posso usar condicionador após utilizá-lo?',
        description: 'Sim. Escolha o melhor condicionador para potencializar ainda mais os efeitos.',
      },
    ],
  },
  {
    code: 6,
    id: '6f9919da-d5cc-4948-88ae-5160852cb7b7',
    tinyId: 'F10006',
    name: 'Minoxidil base em espuma',
    path: 'Minoxidil com Trichofoam™️',
    value: 64.9,
    showCart: true,
    hidePriceCart: false,
    oldValue: 89.9,
    subscriptionDiscount: 20,
    category: ProductCategory.HAIR,
    prescriptionLink: prescriptionType.hair,
    image: '/assets/img/cart-images/minoxidil-fundo-produto.jpg',
    slug: 'minoxidil',
    numericSlug: undefined,
    prescriptionRequired: true,
    rating: '4.9',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/minoxidil-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-minoxidil-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/minoxidil-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-minoxidil-2.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/minoxidil-1.png',
        text: 'Crescimento capilar',
      },
      {
        icon: '/assets/img/product-page-advantages/minoxidil-2.png',
        text: 'TrichoFoam™ - Em espuma',
      },
      {
        icon: '/assets/img/product-page-advantages/minoxidil-3.png',
        text: 'Não contém álcool',
      },
      {
        icon: '/assets/img/product-page-advantages/minoxidil-4.png',
        text: 'Controla a queda capilar',
      },
      {
        icon: '/assets/img/product-page-advantages/minoxidil-5.png',
        text: 'Regula a oleosidade',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/minoxidil.png',
      imageMobile: '/assets/img/product-page-who-uses/minoxidil-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★★',
          text: 'O melhor minoxidil que eu já usei! Mais forte e mais fácil de passar',
          name: 'Fábio B. - Tatuí',
        },
        {
          stars: '★★★★★',
          text: 'Surpreendente! Já tentei outro mas somente esse funcionou!',
          name: 'José A. - Salvador',
        },
        {
          stars: '★★★★☆',
          text: 'Cheiroso e muito prático. Realmente fez o efeito prometido.',
          name: 'Jefferson G. - São Paulo',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/minoxidil.jpg',
      bannerMobile: '/assets/img/product-page-questions/minoxidil-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: '<p>O melhor medicamento para o crescimento dos fios e estimulação dos bulbos capilares.</p> Composição: Minoxidil base a 5%, TrichoFoam™ e excipientes',
        },
        {
          name: 'Como age?',
          description: 'Vascularizando o local de aplicação, promove a criação de vasos sanguíneos e estimula os bulbos capilares, além de acelerar o crescimento dos fios.',
        },
        {
          name: 'O que esperar?',
          description: 'Após 3 meses de utilização diária, espera-se um crescimento capilar acelerado, mais volume e densidade local, maior irrigação sanguínea no local de aplicação.',
        },
      ],
    },
    productInfo: {
      type: 'QUEDA DE CABELO',
      unity: '55ml',
      duration: 'MEDICAMENTO',
      hideLabel: true,
      text: [ '<p>Minoxidil Base a 5% com TrichoFoam™;</p> Um poderoso medicamento em espuma, que acelera o crescimento dos fios e o aumento da circulação sanguínea no local de aplicação.' ],
      subText: 'Venda sob prescrição médica. <a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/minoxidil.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/minoxidil-1.jpg',
        title: 'Eficácia comprovada',
        text: 'Um dos poucos do mercado que utiliza minoxidil base, o mais forte e referênciado em todos os estudos clínicos. Associado à tecnologia TrichoFoam™, é um dos medicamentos mais potêntes contra a queda capilar.'
      },
      {
        image: '/assets/img/product-page-about/minoxidil-2.jpg',
        title: 'Mais prático',
        text: 'Com uma tecnologia exclusiva, possui rápida absorção, não escorre, não deixa esbranquiçado e ainda penetra nas camadas mais profundas do couro cabeludo.'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-minoxidil-1.png',
      '/assets/img/cart-images/minoxidil-fundo-produto.jpg',
    ],
    rightDescription: 'Um grande aliado ao combate da queda capilar, pois ajuda na multiplicação das células dos cabelos e na circulação sanguínea na cabeça.<br/><br/>Minoxidil Base a 5% e TrichoFoam™️ forma um ativo ainda mais poderoso, já que não deixa pontos esbranquiçados e penetra facilmente no couro cabeludo.<br/><br/>Não contém álcool em sua composição. <br/><strong>Sua única preocupação será qual penteado escolher.</strong><br/><br/>Venda sob prescrição médica.',
    description: {
      title: 'O que é o minoxidil?',
      text: 'É um medicamento aprovado pela Anvisa e FDA que promove aumento de circulação e oxigenação local, favorecendo a multiplicação das células capilares, sendo um tratamento comum e eficaz para a alopécia.<br /><br />Sua formulação de <strong>Minoxodil base a 5% com TrichoFoam™</strong> forma um composto super poderoso, que age sob os folículos capilares ainda vivos, estimulando o bulbo e o crescimento capilar. Por se tratar de um medicamento, seu uso deve ser prescrito por um médico.<br /><br />Para saber se é necessário seu uso, <a href="/avaliacao">consulte um médico independente agora.</a>',
    },
    descriptionImage: '/assets/img/products-images/the-mens-minoxidil-desc.jpg',
    amounts: [
      {
        value: 55,
        label: 'ml',
      },
    ],
    infos: {
      left: [
        {
          title: 'TrichoFoam ™',
          description: 'Veículo ideal e estável, formador de\nespuma e livre de álcool, para aplicação\nlocalizada. Não causa manchas, irritações\ne nem ressecamentos capilares.',
        },
      ],
      right: [
        {
          title: 'Óleos essenciais',
          description: 'Composto de óleos essenciais de alecrim,\njuniperus, sândalo, lavanda, melaleuca e eucalipto,\nque atuam como desobstruidores dos folículos\ncapilares, auxiliando no controle da queda dos fios\ne regulando o excesso de oleosidade.',
        },
      ],
    },
    faq: [
      {
        title: 'Posso usar todos os dias?',
        description: 'Deve-se utilizar o medicamento de acordo com a prescrição médica. Contudo, após estudos, padronizou-se para homens o uso do Minoxidil a 5% para todos os pacientes duas vezes ao dia.\nRecomenda-se passar 0.9ml do produto em cada aplicação, sempre nos cabelos secos.\nÉ importante ressaltar que o produto deve ser passado na área do couro cabeludo afetada pela queda, pois ele age na raiz dos cabelos e não na haste dos fios.\n',
      },
      {
        title: 'Posso lavar a área aplicada após seu uso?',
        description: 'Para obter-se o efeito desejado, deve-se deixar a medicação agindo localmente por pelo menos 4 horas. Por isso, seu uso é indicado à noite e pela manhã, logo após o banho.',
      },
      {
        title: 'Mulheres podem usar esse produto?',
        description: 'A concentração de Minoxidil varia de acordo com o sexo biológico. Assim, deve-se seguir a devida recomendação médica para cada caso.',
      },
      {
        title: 'Por quanto tempo tenho que usar?',
        description: 'Deve-se utilizar o produto por no mínimo um intervalo de 3 a 6 meses para resultados satisfatórios. O tratamento contínuo é indispensável para a manutenção da cabeleira.',
      },
      {
        title: 'Posso usar para crescer a barba?',
        description: 'Apesar de inúmeros testes empíricos sugerirem que o Minoxidil tem efeito no crescimento da barba, não há aprovação pelo FDA e ANVISA para seu uso. Para casos de falha na barba ou crescimento, conheça nosso tônico com auxina tricógena.',
      },
      {
        title: 'Quando vou ver os primeiros resultados?',
        description: 'Após 3 meses de uso, começa-se a notar os primeiros resultados.',
      },
      {
        title: 'Posso usar mesmo tendo o couro cabeludo muito sensível ?',
        description: 'Por utilizar o TrichoFoam™ que é um veículo formador de espuma livre de álcool e propilenoglicol, a possibilidade de irritação é baixa. Caso ocorra alguma sensibilidade, suspenda imediatamente o uso e consulte um médico especialista.',
      },
      {
        title: 'Efeitos Adversos',
        description: 'Alguns pacientes podem ter uma queda capilar temporária nas primeiras semanas do tratamento. Isto ocorre porque o medicamento induz à perda dos fios para depois estimular seu crescimento.\n\nIrritações no couro cabeludo (ressecamento, prurido e eritema) são raros, mas caso ocorra, suspenda o uso e converse com seu médico.',
      },
    ],
  },
  {
    code: 7,
    id: '40c5747d-1b87-4768-a3aa-c1186a9e3b1f',
    tinyId: 'F10004',
    name: 'Finasterida',
    path: 'Finasterida',
    showCart: true,
    hidePriceCart: false,
    value: 28.9,
    subscriptionDiscount: 20,
    category: ProductCategory.HAIR,
    prescriptionLink: prescriptionType.hair,
    image: '/assets/img/cart-images/finasterida-fundo-produto.jpg',
    slug: 'finasterida',
    numericSlug: undefined,
    prescriptionRequired: true,
    rating: '5.0',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/finasterida-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-finasterida-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/finasterida-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-finasterida-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/finasterida-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-finasterida-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/finasterida-1.png',
        text: 'Pílula mais prescrita no mundo',
      },
      {
        icon: '/assets/img/product-page-advantages/finasterida-2.png',
        text: 'Interrompe a queda capilar',
      },
      {
        icon: '/assets/img/product-page-advantages/finasterida-3.png',
        text: 'Aprovado pela Anvisa e FDA',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/finasterida.png',
      imageMobile: '/assets/img/product-page-who-uses/finasterida-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★★',
          text: 'Fiquei com receio de utilizar. Não senti nenhum efeito colateral, apenas a volta dos meus cabelos',
          name: 'Gustavo G. - Santa Catarina',
        },
        {
          stars: '★★★★★',
          text: 'Realmente é um medicamento que funciona, tomo todos os dias de manhã e já vi resultados',
          name: 'Henrique J. - Jacareí',
        },
        {
          stars: '★★★★☆',
          text: 'Fiz a consulta online, o medico me prescreveu e em pouco tempo já estou com cabelos nascendo.',
          name: 'Bruno E. - Mato Grosso do Sul',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/finasterida.jpg',
      bannerMobile: '/assets/img/product-page-questions/finasterida-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: '<p>O medicamento mais prescrito no mundo para acabar com a queda capilar.</p> Composição: Finasterida 1mg',
        },
        {
          name: 'Como age?',
          description: 'Bloqueando os receptores de DHT (Di-hidrotestosterona) das células capilares, cessando assim a queda capilar por fatores genéticos',
        },
        {
          name: 'O que esperar?',
          description: 'Após 2 a 3 meses de utilização diária, espera-se uma redução significativa na queda capilar bem como o fim do afinamento dos fios',
        },
      ],
    },
    productInfo: {
      type: 'QUEDA DE CABELO',
      unity: '30',
      duration: '1 MÊS',
      text: [ 'O medicamento mais prescrito no mundo que combate a queda capilar. Aprovado pela Anvisa e FDA, bloqueia a ação do DHT (dihidrotestosterona), hormônio responsável pela queda de cabelo em homens.' ],
      subText: 'Venda sob prescrição médica. <a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/finasterida.png',
    },
    images: [
      '/assets/img/products-images/the-mens-finasterida-1.png',
      '/assets/img/cart-images/finasterida-fundo-produto.jpg',
    ],
    rightDescription: 'Medicamento aprovado pela Anvisa e FDA, com eficiência comprovada, que bloqueia a ação do DHT (dihidrotestosterona), hormônio responsável pela queda de cabelo em homens.<br /><br />Venda sob prescrição médica.',
    description: {
      title: 'O que é finasterida?',
      text: 'Um medicamento indicado no tratamento da calvície. Aprovado pelo FDA em 1992 e pela ANVISA em 1998, ele é comumente utilizado, já que age bloqueando a enzima que transforma a testosterona em DHT, hormônio responsável pela queda de cabelo. Venda sob prescrição médica.<br /><br />Para saber se é necessário seu uso, <a href="/avaliacao">consulte um médico independente agora.</a>',
    },
    descriptionImage: '/assets/img/products-images/the-mens-finasterida-desc.jpg',
    amounts: [
      {
        value: 30,
        label: 'cápsulas',
      },
    ],
    faq: [
      {
        title: 'Posso usar todos os dias?',
        description: 'Siga a orientação médica. Normalmente, recomenda-se uma dose ao dia. A finasterida 1mg não agirá mais rápido, ou melhor, se você tomar mais de uma vez ao dia.',
      },
      {
        title: 'Há contraindicação?',
        description: 'Sim. Pacientes com hipersensibilidade a qualquer componente do produto. A finasterida de 1 mg não é indicada para mulheres ou crianças.',
      },
      {
        title: 'Posso combinar a finasterida com outros medicamentos?',
        description: 'A finasterida em geral não interfere com outros medicamentos. Contudo, recomenda-se falar com seu médico.',
      },
      {
        title: 'Mulheres e crianças podem usar esse produto?',
        description: 'Não. A finasterida é indicada apenas ao sexo biológico masculino.',
      },
      {
        title: 'Por quanto tempo tenho que usar?',
        description: 'Deve-se utilizar o produto de acordo com a orientação médica. Os resultados começam a aparecer de forma mais satisfatória a partir do 3º mês.',
      },
      {
        title: 'Quando vou ver os primeiros resultados?',
        description: 'Após 2 meses de uso, começa-se a notar os primeiros resultados.',
      },
      {
        title: 'Há reações adversas?',
        description: 'Como qualquer medicamento, há reações adversas. Contudo, todas reações ocorreram em menos de 1.8% da população amostral.',
      },
      {
        title: 'Posso usar para crescer a barba?',
        description: 'A finasterida foi desenvolvida para o tratamento de queda de cabelo. Contudo, estudos identificaram o crescimento de barba e pelos, mas não de maneira satisfatória. Assim, sugerimos usar nosso Tônico para crescimento da barba que fecha as falhas e dá volume.',
      },
    ],
  },
  {
    code: 8,
    id: 'e743ec60-df88-4f4b-ac84-748be2473d2b',
    tinyId: 'F10009',
    name: 'Sleep Gummy',
    soldOff: true,
    value: 99.9,
    showCart: true,
    hidePriceCart: false,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionLink: prescriptionType.sleep,
    prescriptionRequired: true,
    rating: '4.8',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/sleep-gummy-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-sleep-gummy-3.png',
      },
      {
        banner: '/assets/img/product-page-carousel/sleep-gummy-2.png',
        mini: '/assets/img/product-page-carousel/mini-sleep-gummy-2.png',
      },
      {
        banner: '/assets/img/product-page-carousel/sleep-gummy-1.png',
        mini: '/assets/img/product-page-carousel/mini-sleep-gummy-1.png',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/sleep-gummy-1.png',
        text: 'Clareza mental',
      },
      {
        icon: '/assets/img/product-page-advantages/sleep-gummy-2.png',
        text: 'Mais disposição ao acordar',
      },
      {
        icon: '/assets/img/product-page-advantages/sleep-gummy-3.png',
        text: 'Mais energia o dia todo',
      },
      {
        icon: '/assets/img/product-page-advantages/sleep-gummy-4.png',
        text: 'Mais foco e produtividade',
      },
      {
        icon: '/assets/img/product-page-advantages/sleep-gummy-5.png',
        text: 'Bom-humor com frequência',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/sleep-gummy.png',
      imageMobile: '/assets/img/product-page-who-uses/sleep-gummy-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★☆',
          text: 'Senti minha mente clarear, me sinto muito mais disposto e produtivo',
          name: 'João M. - Bahia',
        },
        {
          stars: '★★★★★',
          text: 'Sensacional! Realmente funciona. Não lembrava mais como era dormir bem e acordar com a mente tranquila',
          name: 'Matheus B. - São Paulo',
        },
        {
          stars: '★★★★☆',
          text: 'É muito boaaa! Dá vontade de comer mais e eu durmo super bem! Realmente Funciona!',
          name: 'Sarah B. - São Paulo',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/sleep-gummy1.jpg',
      bannerMobile: '/assets/img/product-page-questions/sleep-gummy-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: 'Uma goma de gelatina desenvolvida por um grupo de estudo renomado composto por: médicos, farmacêuticos e químicos. Uma inovação no mercado Brasileiro, com <strong>fórmula exclusiva</strong> para que a sensação da insônia e da indisposição matinal sejam eliminadas',
        },
        {
          name: 'Como age?',
          description: 'Você começa a absorver a Sleep Gummy desde a primeira mordida, o que acelera sua ação no corpo. A metabolização completa ocorrerá em até 1h30, tendo nesse período o seu pico de ação, induzindo-o ao sono.',
        },
        {
          name: 'O que esperar?',
          description: 'Ao ministrá-la, nos primeiros dias seu corpo ainda estará se adaptando. Assim, poderá dormir mais rápido que o normal e acordar mais cedo que de costume. Após a 1ª semana, o horário de dormir poderá ser mantido  até atingir a quantidade adequada de acordo com a resposta do seu organismo, que poderá variar para cada pessoa.',
        },
      ],
    },
    about: [
      {
        image: '/assets/img/product-page-about/sleep-gummy-1.jpg',
        title: 'Natural',
        text: 'A melatonina é um hormônio já produzido e liberado por nossos corpos à noite - é a maneira do nosso corpo nos dizer que é hora de dormir.'
      },
      {
        image: '/assets/img/product-page-about/sleep-gummy-2.jpg',
        title: 'Maior pureza',
        text: 'Aqui você encontra a maior pureza por gummy, são 99.3% de melatonina! O sono é induzido mais rápido. Mas vá com calma, o ursinho é forte.'
      },
      {
        image: '/assets/img/product-page-about/sleep-gummy-3.jpg',
        title: 'Absorção rápida',
        text: 'Antes que você se pergunte, "mas por que em gummy?", nós te respondemos: a absorção começa quando você coloca na boca.'
      },
    ],
    image: '/assets/img/cart-images/sleep-gummy-fundo-produto-2.jpg',
    slug: 'sleep-gummy',
    numericSlug: '9847293873423',
    slugToUse: 'numericSlug',
    advantagesHeader: 'Existem muitos benefícios de ter um sono regulado, os principais são³:',
    rightDescription: 'Acabe com noites mal dormidas, insônia, indisposição matinal e Jet Legs! Pote com 30 gummies de melatonina com 99.3% de pureza em sua composição. Durma bem e tenha mais disposição ao acordar.',
    description: {
      title: 'O que é\nSleep Gummy?',
      text: 'A Gummy é um medicamento, feito à base de gelatina zero açúcar, com 99.3% grau de pureza de melatonina. Produzido naturalmente pelo nosso organismo, a melatonina possuí como principal função regular o relógio biológico, fazendo com que funcione normalmente. Além disso, a melatonina promove o bom funcionamento do organismo e atua como antioxidante, além de diminuir crises de enxaqueca. \n',
    },
    images: [
      '/assets/img/products-images/the-mens-sleep-gummy-2.png',
      '/assets/img/products-images/the-mens-sleep-gummy-1.png',
      '/assets/img/cart-images/sleep-gummy-fundo-produto-2.jpg',
    ],
    productInfo: {
      type: 'SONO',
      unity: '30',
      duration: '1 MÊS',
      text: [ 'Auxilia a dormir melhor e acordar com mais disposição', ' Frasco com 30 doses de melatonina com 99.3% de pureza.' ],
      subText: 'Venda sob prescrição médica. <a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/sleep-gummy.png',
    },
    infos: {
      left: [
        {
          stars: '★★★★☆',
          text: 'Senti minha mente clarear, me sinto muito mais disposto e produtivo',
          name: 'João M. - Bahia',
        },
        {
          stars: '★★★★★',
          text: 'Sensacional! Realmente funciona. Não lembrava mais como era dormir bem e acordar com a mente tranquila',
          name: 'Matheus B. - São Paulo',
        },
        {
          stars: '★★★★☆',
          text: 'É muito boaaa! Dá vontade de comer mais e eu durmo super bem! Realmente Funciona!',
          name: 'Sarah B. - São Paulo',
        },
      ]
    },
    faq: [
      {
        title: 'Posso usar todos os dias?',
        description: 'Siga a orientação médica. Normalmente, recomenda-se uma dose ao dia.',
      },
      {
        title: 'Devo tomar quantas horas antes de dormir?',
        description: 'Deve-se ingerir de 1-2 horas antes de dormir e nunca de estômago vazio.',
      },
      {
        title: 'Por quanto tempo tenho que usar?',
        description: 'Deve-se utilizar o produto de acordo com a orientação médica.',
      },
      {
        title: 'A Sleep tem açúcar?',
        description: 'Não. Nossa Sleep é composta por gelatina sem açúcar. Em sua composição, tem-se basicamente polióis. São 8kcal apenas por dose.'
      },
    ],
    otherInformations: [
      '* Melatonina é um hormônio natural do sono e no Brasil considerado um suplemento alimentar. A dose recomendada é de até 0,21mg. O uso deve ocorrer apenas em maiores de 19 anos e é contra indicado para lactantes, gestantes e pessoas sensíveis aos ingredientes.',
      ' ',
      '1. Andersen LP; Gogenur I; Rosenberg J et al. The safety of melatonin in humans. Clin Drug Investig (2016) 36:169-75.',
      ' ',
      '2. Informação obtida através da Fabricante Tianjin Harmony Technology',
      '3. Rosa, R. C; Borja, A. O uso da melatonina na insônia. Revista acadêmica Oswaldo Cruz, São Paulo, v. 23, n.6 jul-set. 2019.',
      '3.1. Reiter, R. J. Melatonin: Clinical Relevance. Best Practice & Research Clinical Endocrinology and Metabolism 2003;17(2):273-85.',
      '3.2. Tordjman, S. et al. Melatonin: Pharmacology, Functions and Therapeutic Benefits. Current Neuropharmacology 2017;15:434-43.',
      ' ',
      '3.3. Cipolla-Neto, J.; Amaral, F. G. Melatonin as a hormone: new physiological and clinical insights. Endocrine Reviews, v. 39, p. 990-1028, 2018.',
      '3.4.Reid KJ, McGee-Koch LL, Zee PC. Cognition in circadian rhythm sleep disorders. Prog Brain Res 2011;190:3–20.'
    ],
    warnings: [ 'Grupo populacional a que se destina: adultos acima de 19 anos. ', 'Este produto não deve ser consumido por gestantes, lactantes, crianças e pessoas envolvidas em atividades que requerem atenção constante. ', 'Pessoas com enfermidades e/ou sob o uso de medicamentos, consultem seu médico antes de consumir o produto. ', 'Não exceder a recomendação diária de consumo indicada por seu médico.' ]
  },
  {
    code: 9,
    id: '12e3db3c-1404-40a2-ae13-a9b3fd09de11',
    name: 'Combo Barbudo',
    isCombo: true,
    oldValue: null,
    showCart: true,
    hidePriceCart: false,
    value: 149.9,
    discountPercent: '',
    category: ProductCategory.BEARD,
    prescriptionRequired: false,
    image: '/assets/img/cart-images/combo-barbudo-fundo-produto.jpg',
    slug: 'combo-barbudo',
    numericSlug: undefined,
    description: {
      title: 'Combo',
      text: 'Tônico para barba 30ml + Vita Gummy 30unid.',
    },
    images: [
      '/assets/img/best-seller/barbudo-hc.png',
      '/assets/img/cart-images/combo-barbudo-fundo-produto.jpg',
    ],
    descriptionImage: '/assets/img/best-seller/combo-barbudo.png',
    amounts: [],
    infos: {},
    faq: [],
  },
  {
    code: 10,
    id: '8af6c1be-3cd6-41a9-856c-452b9a66db1f',
    name: 'Combo Vita Gummy 30unid',
    isCombo: true,
    oldValue: null,
    showCart: true,
    hidePriceCart: false,
    value: 199.9,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    image: '/assets/img/cart-images/trio-vita-gummy-fundo-produto.jpg',
    slug: 'combo-gummy',
    numericSlug: undefined,
    description: {
      title: 'Combo',
      text: 'Tônico para barba 30ml + Vita Gummy 30unid.',
    },
    images: [
      '/assets/img/best-seller/combo-gummy-hc.png',
      '/assets/img/cart-images/trio-vita-gummy-fundo-produto.jpg',
    ],
    descriptionImage: '/assets/img/best-seller/combo-gummy.png',
    amounts: [],
    infos: {},
    faq: [],
  },
  {
    code: 9,
    id: '12e3db3c-1404-40a2-ae13-a9b3fd09de11',
    name: 'Combo Barbudo',
    isCombo: true,
    oldValue: null,
    showCart: true,
    hidePriceCart: false,
    value: 149.9,
    discountPercent: '',
    category: ProductCategory.BEARD,
    prescriptionRequired: false,
    image: '/assets/img/cart-images/combo-barbudo-fundo-produto.jpg',
    slug: 'combo-barbudo',
    numericSlug: undefined,
    description: {
      title: 'Combo',
      text: 'Tônico para barba 30ml + Vita Gummy 30unid.',
    },
    images: [
      '/assets/img/best-seller/combo-barbudo.png',
      '/assets/img/cart-images/combo-barbudo-fundo-produto.jpg',
    ],
    descriptionImage: '/assets/img/best-seller/combo-barbudo.png',
    amounts: [],
    infos: {},
    faq: [],
  },
  {
    code: 11,
    id: 'hdaRHADRHBADRTHBAD',
    tinyId: 'F10045',
    name: 'Chocosono - Zero Açucar',
    path: 'Chocosono',
    soldOff: false,
    showCart: true,
    hidePriceCart: false,
    value: 59.9,
    category: ProductCategory.HEALTH,
    prescriptionLink: prescriptionType.sleep,
    image: '/assets/img/product-variants/chocosono-1.png',
    slug: 'chocosono',
    numericSlug: undefined,
    prescriptionRequired: false,
    rating: '5.0',
    wyntk: '/assets/img/product-page-info/chocosono-wyntk1.png',
    warning: {
      text: '1% das vendas serão doados para projetos sociais de saúde mental',
      color: '#E5D3C1',
      background: '#724439'
    },
    hasVariant: {
      baseValue: 29.9,
      hideQuantity: true,
      hideCep: false,
      whoCanUse: '/assets/img/product-page-info/male-female.png',
      variants: [
        {
          id: '3c1ca3a0-8bb4-4419-aac8-ef2e1ed3c136',
          name: '5 caixas',
          unitPrice: '(R$ 11,98/caixa)',
          price: 59.9,
          image: '/assets/img/product-variants/chocosono-2.png',
          qtd: 1,
          prescriptionRequired: false,
          category: ProductCategory.HEALTH,
          prescriptionLink: prescriptionType.sleep,
          images: [ '/assets/img/product-variants/chocosono-2.png' ],
        },
        {
          id: '264b2f6e-d931-4845-a860-4f98bd31c93a',
          name: '7 caixas',
          unitPrice: '(R$ 11,40/caixa)',
          price: 79.90,
          image: '/assets/img/product-variants/chocosono-7.png',
          qtd: 1,
          prescriptionRequired: false,
          category: ProductCategory.HEALTH,
          prescriptionLink: prescriptionType.sleep,
          images: [ '/assets/img/product-variants/chocosono-7.png' ],
        },
        {
          id: 'd8d76d35-1cd0-4d28-b30e-79018c1bb90f',
          name: '10 caixas',
          unitPrice: '(R$ 9,99/caixa)',
          price: 99.90,
          image: '/assets/img/product-variants/chocosono-3.png',
          qtd: 1,
          prescriptionRequired: false,
          category: ProductCategory.HEALTH,
          prescriptionLink: prescriptionType.sleep,
          images: [ '/assets/img/product-variants/chocosono-3.png' ],
        },
        {
          id: '7793256a-4125-4d36-ba35-f336b2b12ff1',
          name: '30 caixas',
          unitPrice: '(R$ 7,99/caixa)',
          price: 239.70,
          image: '/assets/img/product-variants/chocosono-3.png',
          qtd: 1,
          prescriptionRequired: false,
          category: ProductCategory.HEALTH,
          prescriptionLink: prescriptionType.sleep,
          images: [ '/assets/img/product-variants/chocosono-3.png' ],
        },
      ]
    },
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/chocosono-1.jpg',
        mini: '/assets/img/product-page-carousel/chocosono-mini-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/chocosono-2.jpg',
        mini: '/assets/img/product-page-carousel/chocosono-mini-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/chocosono-3.jpg',
        mini: '/assets/img/product-page-carousel/chocosono-mini-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/chocosono-1.png',
        text: 'Pílula mais prescrita no mundo',
      },
      {
        icon: '/assets/img/product-page-advantages/chocosono-2.png',
        text: 'Pílula mais prescrita no mundo',
      },
      {
        icon: '/assets/img/product-page-advantages/chocosono-3.png',
        text: 'Pílula mais prescrita no mundo',
      },
      {
        icon: '/assets/img/product-page-advantages/chocosono-4.png',
        text: 'Pílula mais prescrita no mundo',
      },
      {
        icon: '/assets/img/product-page-advantages/chocosono-5.png',
        text: 'Pílula mais prescrita no mundo',
      },
    ],
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★☆',
          text: 'Senti minha mente clarear, me sinto muito mais disposto e produtivo',
          name: 'João M. - Bahia',
        },
        {
          stars: '★★★★★',
          text: 'Gente do céu, nunca dormi como durmo com chocosono! Produto mais do que aprovado',
          name: 'Danielle N. - São Paulo',
        },
        {
          stars: '★★★★★',
          text: 'Que chocolate maravilhoso! Tem sobremesa melhor? Comer chocolate e ainda dormir super bem?!',
          name: 'Naiara L. - Rio de Janeiro',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/chocosono.png',
      bannerMobile: '/assets/img/product-page-questions/chocosono-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: 'Um chocolate gostoso e funcional a base de melatonina, o hormônio natural do sono. Em uma caixa vem 10 pingos de chocolate com 0,21mg cada. ',
        },
        {
          name: 'Como age?',
          description: 'Deve-se consumir até 1h antes do horário de dormir. A melatonina agirá rapidamente por já começar a ser absorvida na mastigação. Em pouco tempo, a vontade de dormir virá. ',
        },
        {
          name: 'O que esperar?',
          description: '<p>Um momento gostoso e leve que ajuda nosso cérebro a relaxar e a dormir melhor e mais rapidamente. </p><p>Um saquinho de chocosono te ajuda a ter um sono mais profundo e mais reparador.</p>',
        },
      ],
    },
    about: [
      {
        image: '/assets/img/product-page-about/chocosono-1.png',
        title: 'Chocolate funcional',
        text: 'Pesquisas apontam que o chocolate melhora a absorção de vitaminas e suplementos, combate os radicais livres, reduz o stress e a dor e gera a sensação de satisfação e bem-estar, te ajudando a ficar mais confortável e a dormir melhor.'
      },
      {
        image: '/assets/img/product-page-about/chocosono-2.png',
        title: 'O único',
        text: 'Isso mesmo: o único com a melhor combinação: chocolate e melatonina. Aqui você encontra a maior pureza por pingo, são 99.3% de melatonina com 0,21mg cada! O sono virá mais rápido do que imagina'
      },
      {
        image: '/assets/img/product-page-about/chocosono-3.png',
        title: 'Absorção super rápida',
        text: 'Rápido não, super rápido.Isso por que, o chocolate é absorvido desde a hora que você morde, e seus efeitos surgem em minutos. Então, quando for tomar o seu, separe seu pijama.'
      },
    ],
    productInfo: {
      type: 'QUEDA DE CABELO',
      unity: '30',
      duration: '1 MÊS',
      text: [ 'A fórmula perfeita e saborosa para você ter uma boa noite de sono, dormindo profundamente e acordando revigorado.' ],
      subText: '<a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/chocosono.png',
    },
    images: [
      '/assets/img/product-variants/chocosono-1.png',
    ],
    rightDescription: 'Medicamento aprovado pela Anvisa e FDA, com eficiência comprovada, que bloqueia a ação do DHT (dihidrotestosterona), hormônio responsável pela queda de cabelo em homens.<br /><br />Venda sob prescrição médica.',
    description: {
      title: 'O que é finasterida?',
      text: 'Um medicamento indicado no tratamento da calvície. Aprovado pelo FDA em 1992 e pela ANVISA em 1998, ele é comumente utilizado, já que age bloqueando a enzima que transforma a testosterona em DHT, hormônio responsável pela queda de cabelo. Venda sob prescrição médica.<br /><br />Para saber se é necessário seu uso, <a href="/avaliacao">consulte um médico independente agora.</a>',
    },
    descriptionImage: '/assets/img/products-images/the-mens-finasterida-desc.jpg',
    amounts: [
      {
        value: 30,
        label: 'cápsulas',
      },
    ],
    faq: [
      {
        title: 'Posso usar todos os dias?',
        description: 'Sim, por ser um suplemento alimentar, o uso diário está liberado. Atenção, um saquinho é muito mais que o suficiente para uma boa noite de sono. ',
      },
      {
        title: 'Há contraindicação?',
        description: 'Sim. Pessoas com hipersensibilidade a qualquer componente do produto. Além disso, não é indicada para pessoas menores de 19 anos e casos de gravidez e aleitamentos.',
      },
      {
        title: 'Devo tomar quantas horas antes de dormir?',
        description: 'Deve-se consumir até uma hora antes do horário desejado de dormir. ',
      },
      {
        title: 'Por quanto tempo tenho que usar?',
        description: 'Deve-se utilizar pelo tempo que entender ser necessário para regulação do seu sono. O chocosono não vicia, apesar de muitooo gostoso. ',
      },
      {
        title: 'Há reações adversas?',
        description: 'A melatonina é considerada uma substância de baixa toxicidade e uso seguro principalmente se comparada com diversos fármacos de uso comum, principalmente os hipnoindutores. Caso tenha qualquer reação, seu uso deverá ser suspenso imediatamente e o seu médico alertado.',
      },
      {
        title: 'Qual a composição? ',
        description: '<div>Maltitol, Leite em pó integral, Manteiga de cacau, Liquor de cacau, Aroma artificial de baunilha, Goma arábica, Goma laca, Alcool com cereal, Emulsificante (INS 32), Silicato de magnésio (INS 553i), Melatonina. Contém Lactose.</div><div><img src="/assets/img/nutritional/chocosono.png" alt="informação nutricional"/></div>',
      },
    ],
  },
  {
    code: 16,
    id: '20c5bd78-4612-495c-9c6c-0d78416d5896',
    name: 'Chocosono - Zero Açucar - 1 caixa',
    hideQtd: false,
    signature: true,
    oldValue: null,
    showCart: true,
    hidePriceCart: false,
    value: 9.90,
    isPromotionalProduct: true,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    image: '/assets/img/cart-images/chocosono-2caixas-fundo-produto.jpg',
    slug: 'chocosono',
    numericSlug: undefined,
    description: {
      title: 'Chocosono',
      text: 'Chocosono - Zero Açucar - 1 caixa.',
    },
    images: [
      '/assets/img/product-variants/chocosono-1.png',
      '/assets/img/cart-images/chocosono-2caixas-fundo-produto.jpg',
    ],
    descriptionImage: '/assets/img/product-variants/chocosono-1.png',
    amounts: [],
    infos: {},
    faq: [],
  },
  {
    code: 12,
    id: 'de6acabf-8bc1-4a63-bcb5-213c043cef30',
    name: 'Chocosono - Zero Açucar - 2 caixas',
    hideQtd: false,
    signature: true,
    oldValue: null,
    showCart: true,
    hidePriceCart: false,
    value: 26.90,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    image: '/assets/img/cart-images/chocosono-2caixas-fundo-produto.jpg',
    description: {
      title: 'Chocosono',
      text: 'Chocosono - Zero Açucar - 2 caixas.',
    },
    images: [
      '/assets/img/product-variants/chocosono-1.png',
      '/assets/img/cart-images/chocosono-2caixas-fundo-produto.jpg',
    ],
    descriptionImage: '/assets/img/product-variants/chocosono-1.png',
    amounts: [],
    infos: {},
    faq: [],
  },
  {
    code: 13,
    id: '3c1ca3a0-8bb4-4419-aac8-ef2e1ed3c136',
    name: 'Chocosono - Zero Açucar - 5 caixas',
    hideQtd: false,
    signature: true,
    showCart: true,
    hidePriceCart: false,
    oldValue: null,
    value: 59.90,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    image: '/assets/img/cart-images/chocosono-5caixas-fundo-produto.jpg',
    slug: 'chocosono',
    numericSlug: undefined,
    description: {
      title: 'Chocosono',
      text: 'Chocosono - Zero Açucar - 5 caixas.',
    },
    images: [
      '/assets/img/product-variants/chocosono-2.png',
      '/assets/img/cart-images/chocosono-5caixas-fundo-produto.jpg',
    ],
    descriptionImage: '/assets/img/product-variants/chocosono-2.png',
    amounts: [],
    infos: {},
    faq: [],
  },
  {
    code: 25,
    id: '264b2f6e-d931-4845-a860-4f98bd31c93a',
    name: 'Chocosono - Zero Açucar - 7 caixas',
    hideQtd: false,
    showCart: true,
    hidePriceCart: false,
    signature: true,
    oldValue: null,
    value: 79.90,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    image: '/assets/img/cart-images/chocosono-7caixas-fundo-produto.png',
    slug: 'chocosono',
    numericSlug: undefined,
    description: {
      title: 'Chocosono',
      text: 'Chocosono - Zero Açucar - 7 caixas.',
    },
    images: [
      '/assets/img/product-variants/chocosono-7.png',
      '/assets/img/cart-images/chocosono-7caixas-fundo-produto.png',
    ],
    descriptionImage: '/assets/img/product-variants/chocosono-7.png',
    amounts: [],
    infos: {},
    faq: [],
  },
  {
    code: 14,
    id: 'd8d76d35-1cd0-4d28-b30e-79018c1bb90f',
    name: 'Chocosono - Zero Açucar - 10 caixas',
    hideQtd: false,
    oldValue: null,
    signature: true,
    showCart: true,
    hidePriceCart: false,
    value: 99.90,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    image: '/assets/img/cart-images/chocosono-10caixas-fundo-produto.jpg',
    slug: 'chocosono',
    numericSlug: undefined,
    description: {
      title: 'Chocosono',
      text: 'Chocosono - Zero Açucar - 10 caixas.',
    },
    images: [
      '/assets/img/product-variants/chocosono-3.png',
      '/assets/img/cart-images/chocosono-10caixas-fundo-produto.jpg'
    ],
    descriptionImage: '/assets/img/product-variants/chocosono-3.png',
    amounts: [],
    infos: {},
    faq: [],
  },
  {
    code: 23,
    id: '8e0b41aa-a090-4070-90be-53ae9a2cc27e',
    name: 'Chocosono - Zero Açucar - 20 caixas',
    hideQtd: false,
    showCart: true,
    hidePriceCart: false,
    oldValue: null,
    signature: true,
    value: 199.90,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    image: '/assets/img/cart-images/chocosono-10caixas-fundo-produto.jpg',
    slug: 'chocosono',
    numericSlug: undefined,
    description: {
      title: 'Chocosono',
      text: 'Chocosono - Zero Açucar - 20 caixas.',
    },
    images: [
      '/assets/img/product-variants/chocosono-3.png',
      '/assets/img/cart-images/chocosono-10caixas-fundo-produto.jpg'
    ],
    descriptionImage: '/assets/img/product-variants/chocosono-3.png',
    amounts: [],
    infos: {},
    faq: [],
  },
  {
    code: 15,
    id: '7793256a-4125-4d36-ba35-f336b2b12ff1',
    name: 'Chocosono - Zero Açucar - 30 caixas',
    hideQtd: false,
    oldValue: null,
    signature: true,
    showCart: true,
    hidePriceCart: false,
    value: 239.70,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    image: '/assets/img/cart-images/chocosono-10caixas-fundo-produto.jpg',
    slug: 'chocosono',
    numericSlug: undefined,
    description: {
      title: 'Chocosono',
      text: 'Chocosono - Zero Açucar - 30 caixas.',
    },
    images: [
      '/assets/img/product-variants/chocosono-3.png',
      '/assets/img/cart-images/chocosono-10caixas-fundo-produto.jpg',
    ],
    descriptionImage: '/assets/img/product-variants/chocosono-3.png',
    amounts: [],
    infos: {},
    faq: [],
  },
  {
    code: 17,
    id: '8e273410-e1f2-4740-84e1-072490d8ba62',
    name: 'Chocosono - Zero Açucar - 1 caixa',
    hideQtd: false,
    showCart: true,
    hidePriceCart: false,
    signature: true,
    oldValue: null,
    value: 0.00,
    isPromotionalProduct: true,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    image: '/assets/img/cart-images/chocosono-2caixas-fundo-produto.jpg',
    slug: 'chocosono',
    numericSlug: undefined,
    description: {
      title: 'Chocosono',
      text: 'Chocosono 1 caixa',
    },
    images: [
      '/assets/img/product-variants/chocosono-1.png',
      '/assets/img/cart-images/chocosono-2caixas-fundo-produto.jpg',
    ],
    descriptionImage: '/assets/img/product-variants/chocosono-1.png',
    amounts: [],
    infos: {},
    faq: [],
  },
  {
    code: 18,
    id: '6a55247d-6bcd-4073-b090-00e2a38faeda',
    tinyId: 'F10007',
    name: 'Shampoo Energizante',
    showCart: true,
    hidePriceCart: false,
    path: 'Shampoo com H-Vit®',
    value: 42.41,
    oldValue: 49.90,
    subscriptionDiscount: 20,
    category: ProductCategory.HAIR,
    image: '/assets/img/cart-images/shampoo-fundo-produto.jpg',
    slug: 'shampoo-energizante',
    numericSlug: undefined,
    rating: '4.7',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/shampoo-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-shampoo-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/shampoo-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-shampoo-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/shampoo-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-shampoo-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/shampoo-1.png',
        text: 'Limpeza profunda',
      },
      {
        icon: '/assets/img/product-page-advantages/shampoo-2.png',
        text: 'Mais brilho e volume',
      },
      {
        icon: '/assets/img/product-page-advantages/shampoo-3.png',
        text: 'Fortalece os fios fracos',
      },
      {
        icon: '/assets/img/product-page-advantages/shampoo-4.png',
        text: 'Combate a caspa',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/shampoo.png',
      imageMobile: '/assets/img/product-page-who-uses/shampoo-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★☆',
          text: 'Meus fios eram quebradiços e fracos e agora, depois de 1 mês sinto eles muito mais forte!',
          name: 'Thiago C. - Rio Grande do Norte',
        },
        {
          stars: '★★★★★',
          text: 'Impressionante! Minha caspa acabou ',
          name: 'Carlos W. - Porto Alegre',
        },
        {
          stars: '★★★★☆',
          text: 'Cheiroso, gostoso e limpa mesmo o couro cabeludo! Não fica com aspecto de ressecado!!',
          name: 'João A. - São Paulo',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/shampoo.jpg',
      bannerMobile: '/assets/img/product-page-questions/shampoo-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: 'Um shampoo desenvolvido para limpar profundamente o couro cabeludo, gerando um ambiente asséptico, antibactericida e antifungicida: propício para que os nutrientes contidos em sua formulação penetrem com maior facilidade na cabeça, além de deixar um ambiente pronto para receber outro ativos.',
        },
        {
          name: 'Como age?',
          description: 'Atingindo as camadas mais profundas do couro cabeludo, nossa fórmula com H-Vit, Biotina, Pantenol, Café, Jaborandi e outros componentes tonificam os fios e controlam a oleosidade, revitalizando e fortalecendo os fios fracos e quebradiços. Tudo isso com um cheiro gostoso e refrescante.',
        },
        {
          name: 'O que esperar?',
          description: 'Quem utiliza o shampoo, deve esperar a diminuição da oleosidade, a redução da caspa e um cabelo macio e volumoso.',
        },
      ],
    },
    productInfo: {
      type: 'QUEDA DE CABELO',
      unity: '200ml',
      duration: '1 MÊS',
      hideUnity: true,
      hideLabel: false,
      text: [ 'Cheiroso e cheio de nutrientes, nosso shampoo contém ativos que ajudam a revitalizar e fortalecer os fios fracos e quebradiços, além de limpar profundamente o couro cabeludo, garantindo a melhor absorção dos nutrientes.' ],
      subText: '<p>Indicado para todos os tipos de cabelo.</p><p><a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a></p>',
      img: '/assets/img/product-page-info/shampoo.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/shampoo-1.png',
        title: 'Alto rendimento',
        text: 'Com a viscocidade perfeita, uma pequena porção já é suficiente para limpar o seu couro cabeludo e fortalece os fios'
      },
      {
        image: '/assets/img/product-page-about/shampoo-2.png',
        title: 'Comprovação clínica',
        text: 'Testes realizados em laboratório comprovaram uma diminuição significativa da oleosidade em 28 dias de uso, reduzindo assim a caspa e propiciando um ambiente favorável ao crescimento capilar'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-shampoo-energizante-1.png',
      '/assets/img/products-images/the-mens-shampoo-energizante-2.png',
      '/assets/img/cart-images/shampoo-fundo-produto.jpg',
    ],
    rightDescription: 'Cheiroso e cheio de nutrientes, nosso shampoo contém ativos que ajudam a revitalizar e fortalecer os fios fracos e quebradiços, além de limpar profundamente o couro cabeludo, garantindo a melhor absorção dos nutrientes.<br /><br />Indicado para <strong>todos os tipos de cabelo.</strong>',
    description: {
      title: 'O que é o shampoo energizante?',
      text: 'Um shampoo desenvolvido para limpar profundamente o couro cabeludo, gerando um ambiente asséptico, antibactericida e antifungicida: propício para que os nutrientes contidos em sua formulação, penetrem com maior facilidade na cabeça, além de deixar um ambiente pronto para receber outro ativos.<br/><br/>Nossa fórmula com H-Vit, Biotina, Pantenol, Café, Jaborandi e outros componentes é ideal para tonificar os fios e controlar a oleosidade, ajudando também a revitalizar e fortalecer os fios fracos e quebradiços, ainda, com um cheiro gostoso, limpa e refresca o couro cabeludo.<br/><br/>Livre de sulfatos, sal (cloreto de sódio) e parabenos.',
    },
    descriptionImage: '/assets/img/products-images/the-mens-shampoo-energizante-desc.jpg',
    amounts: [
      {
        value: 200,
        label: 'ml',
      },
    ],
    infos: {
      left: [
        {
          title: 'Biotina',
          description: 'Auxilia na formação de queratina.\nAlém disso, mantém o couro cabeludo,\nhidratado, ajuda no crescimento saudável\ndos fios e no combate a caspa.',
        },
        {
          title: 'Pantenol',
          description: 'Ativa o ácido pantotênico, essencial para\nrepor os níveis de proteína e lipídios do\ncouro cabeludo. Proporcionando brilho e\nhidratação para os fios.',
        },
        {
          title: 'Extrato de Jaborandi',
          description: 'Princípio ativo que proporciona ação adstringente,\npromove a limpeza profunda do couro cabeludo,\ncombatendo a oleosidade e a seborreia.',
        },
      ],
      right: [
        {
          title: 'H-Vit ®',
          description: 'Super complexo multivitamínico que controla a\noleosidade da pele e couro cabeludo, promove\nrestauração da barreira cutânea, fortalece o bulbo\ncapilar, auxiliando na prevenção da queda.',
        },
        {
          title: 'Abietoil',
          description: 'Um tensoativo vegetal de alta afinidade\ncom a pele e cabelos. Promove a redução\nda oleosidade, reequilibrando a função\nsebácea sem ressecar os fios.',
        },
        {
          title: 'Fios extratos tonificantes',
          description: 'Ações estimulantes, tonificantes, antisséptica,\ncicatrizante, protetora, hidratante, regeneradora\ne anti-inflamatória. Dando maciez aos cabelos\natravés dos derivados de celulose.',
        },
      ],
    },
    faq: [
      {
        title: 'Posso usar todos os dias?',
        description: 'Nosso Shampoo deve ser usado, ao menos, uma vez ao dia.',
      },
      {
        title: 'Tenho o couro cabeludo muito sensível, posso usar o Shampoo energizante?',
        description: 'Sim, nosso shampoo é dermatologicamente testado.',
      },
      {
        title: 'Se eu usar apenas 1 mês vai ter efeito?',
        description: 'Para que o tratamento seja eficaz, recomendamos o uso de nosso shampoo energizante por pelo menos 3 meses, porém os resultados variam de acordo com cada pessoa. Para um melhor resultado, conheça nosso hair kit.',
      },
      {
        title: 'Como devo usar esse shampoo?',
        description: 'Tire a roupa, entre no chuveiro, molhe os cabelos  e aplique uma quantidade pequena do shampoo sobre as mãos. Leve-as ao couro cabeludo e massageie-o até formar uma espuma rica e cheirosa. Enxágue e repita o processo.',
      },
      {
        title: 'Ele resseca os cabelos?',
        description: 'Não. Nosso shampoo foi desenvolvido para limpar profundamente o couro cabeludo e os fios, mas sem ressecá-los e gerar pontas duplas.',
      },
      {
        title: 'Posso usar condicionador após utilizá-lo?',
        description: 'Sim. Escolha o melhor condicionador para potencializar ainda mais os efeitos.',
      },
    ],
  },
  {
    code: 40,
    id: '6be92422-ab26-4a22-8f36-e12a6232dbf4',
    tinyId: 'F10007',
    name: 'Shampoo Energizante',
    showCart: true,
    hidePriceCart: false,
    path: 'Shampoo com H-Vit®',
    value: 22.9,
    oldValue: 49.90,
    subscriptionDiscount: 20,
    category: ProductCategory.HAIR,
    image: '/assets/img/cart-images/shampoo-fundo-produto.jpg',
    slug: 'shampoo-energizante',
    numericSlug: undefined,
    rating: '4.7',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/shampoo-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-shampoo-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/shampoo-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-shampoo-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/shampoo-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-shampoo-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/shampoo-1.png',
        text: 'Limpeza profunda',
      },
      {
        icon: '/assets/img/product-page-advantages/shampoo-2.png',
        text: 'Mais brilho e volume',
      },
      {
        icon: '/assets/img/product-page-advantages/shampoo-3.png',
        text: 'Fortalece os fios fracos',
      },
      {
        icon: '/assets/img/product-page-advantages/shampoo-4.png',
        text: 'Combate a caspa',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/shampoo.png',
      imageMobile: '/assets/img/product-page-who-uses/shampoo-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★☆',
          text: 'Meus fios eram quebradiços e fracos e agora, depois de 1 mês sinto eles muito mais forte!',
          name: 'Thiago C. - Rio Grande do Norte',
        },
        {
          stars: '★★★★★',
          text: 'Impressionante! Minha caspa acabou ',
          name: 'Carlos W. - Porto Alegre',
        },
        {
          stars: '★★★★☆',
          text: 'Cheiroso, gostoso e limpa mesmo o couro cabeludo! Não fica com aspecto de ressecado!!',
          name: 'João A. - São Paulo',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/shampoo.jpg',
      bannerMobile: '/assets/img/product-page-questions/shampoo-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: 'Um shampoo desenvolvido para limpar profundamente o couro cabeludo, gerando um ambiente asséptico, antibactericida e antifungicida: propício para que os nutrientes contidos em sua formulação penetrem com maior facilidade na cabeça, além de deixar um ambiente pronto para receber outro ativos.',
        },
        {
          name: 'Como age?',
          description: 'Atingindo as camadas mais profundas do couro cabeludo, nossa fórmula com H-Vit, Biotina, Pantenol, Café, Jaborandi e outros componentes tonificam os fios e controlam a oleosidade, revitalizando e fortalecendo os fios fracos e quebradiços. Tudo isso com um cheiro gostoso e refrescante.',
        },
        {
          name: 'O que esperar?',
          description: 'Quem utiliza o shampoo, deve esperar a diminuição da oleosidade, a redução da caspa e um cabelo macio e volumoso.',
        },
      ],
    },
    productInfo: {
      type: 'QUEDA DE CABELO',
      unity: '200ml',
      duration: '1 MÊS',
      hideUnity: true,
      hideLabel: false,
      text: [ 'Cheiroso e cheio de nutrientes, nosso shampoo contém ativos que ajudam a revitalizar e fortalecer os fios fracos e quebradiços, além de limpar profundamente o couro cabeludo, garantindo a melhor absorção dos nutrientes.' ],
      subText: '<p>Indicado para todos os tipos de cabelo.</p><p><a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a></p>',
      img: '/assets/img/product-page-info/shampoo.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/shampoo-1.png',
        title: 'Alto rendimento',
        text: 'Com a viscocidade perfeita, uma pequena porção já é suficiente para limpar o seu couro cabeludo e fortalece os fios'
      },
      {
        image: '/assets/img/product-page-about/shampoo-2.png',
        title: 'Comprovação clínica',
        text: 'Testes realizados em laboratório comprovaram uma diminuição significativa da oleosidade em 28 dias de uso, reduzindo assim a caspa e propiciando um ambiente favorável ao crescimento capilar'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-shampoo-energizante-1.png',
      '/assets/img/products-images/the-mens-shampoo-energizante-2.png',
      '/assets/img/cart-images/shampoo-fundo-produto.jpg',
    ],
    rightDescription: 'Cheiroso e cheio de nutrientes, nosso shampoo contém ativos que ajudam a revitalizar e fortalecer os fios fracos e quebradiços, além de limpar profundamente o couro cabeludo, garantindo a melhor absorção dos nutrientes.<br /><br />Indicado para <strong>todos os tipos de cabelo.</strong>',
    description: {
      title: 'O que é o shampoo energizante?',
      text: 'Um shampoo desenvolvido para limpar profundamente o couro cabeludo, gerando um ambiente asséptico, antibactericida e antifungicida: propício para que os nutrientes contidos em sua formulação, penetrem com maior facilidade na cabeça, além de deixar um ambiente pronto para receber outro ativos.<br/><br/>Nossa fórmula com H-Vit, Biotina, Pantenol, Café, Jaborandi e outros componentes é ideal para tonificar os fios e controlar a oleosidade, ajudando também a revitalizar e fortalecer os fios fracos e quebradiços, ainda, com um cheiro gostoso, limpa e refresca o couro cabeludo.<br/><br/>Livre de sulfatos, sal (cloreto de sódio) e parabenos.',
    },
    descriptionImage: '/assets/img/products-images/the-mens-shampoo-energizante-desc.jpg',
    amounts: [
      {
        value: 200,
        label: 'ml',
      },
    ],
    infos: {
      left: [
        {
          title: 'Biotina',
          description: 'Auxilia na formação de queratina.\nAlém disso, mantém o couro cabeludo,\nhidratado, ajuda no crescimento saudável\ndos fios e no combate a caspa.',
        },
        {
          title: 'Pantenol',
          description: 'Ativa o ácido pantotênico, essencial para\nrepor os níveis de proteína e lipídios do\ncouro cabeludo. Proporcionando brilho e\nhidratação para os fios.',
        },
        {
          title: 'Extrato de Jaborandi',
          description: 'Princípio ativo que proporciona ação adstringente,\npromove a limpeza profunda do couro cabeludo,\ncombatendo a oleosidade e a seborreia.',
        },
      ],
      right: [
        {
          title: 'H-Vit ®',
          description: 'Super complexo multivitamínico que controla a\noleosidade da pele e couro cabeludo, promove\nrestauração da barreira cutânea, fortalece o bulbo\ncapilar, auxiliando na prevenção da queda.',
        },
        {
          title: 'Abietoil',
          description: 'Um tensoativo vegetal de alta afinidade\ncom a pele e cabelos. Promove a redução\nda oleosidade, reequilibrando a função\nsebácea sem ressecar os fios.',
        },
        {
          title: 'Fios extratos tonificantes',
          description: 'Ações estimulantes, tonificantes, antisséptica,\ncicatrizante, protetora, hidratante, regeneradora\ne anti-inflamatória. Dando maciez aos cabelos\natravés dos derivados de celulose.',
        },
      ],
    },
    faq: [
      {
        title: 'Posso usar todos os dias?',
        description: 'Nosso Shampoo deve ser usado, ao menos, uma vez ao dia.',
      },
      {
        title: 'Tenho o couro cabeludo muito sensível, posso usar o Shampoo energizante?',
        description: 'Sim, nosso shampoo é dermatologicamente testado.',
      },
      {
        title: 'Se eu usar apenas 1 mês vai ter efeito?',
        description: 'Para que o tratamento seja eficaz, recomendamos o uso de nosso shampoo energizante por pelo menos 3 meses, porém os resultados variam de acordo com cada pessoa. Para um melhor resultado, conheça nosso hair kit.',
      },
      {
        title: 'Como devo usar esse shampoo?',
        description: 'Tire a roupa, entre no chuveiro, molhe os cabelos  e aplique uma quantidade pequena do shampoo sobre as mãos. Leve-as ao couro cabeludo e massageie-o até formar uma espuma rica e cheirosa. Enxágue e repita o processo.',
      },
      {
        title: 'Ele resseca os cabelos?',
        description: 'Não. Nosso shampoo foi desenvolvido para limpar profundamente o couro cabeludo e os fios, mas sem ressecá-los e gerar pontas duplas.',
      },
      {
        title: 'Posso usar condicionador após utilizá-lo?',
        description: 'Sim. Escolha o melhor condicionador para potencializar ainda mais os efeitos.',
      },
    ],
  },
  {
    code: 41,
    id: 'a7aea138-aa39-4651-b644-4967e36afe8c',
    tinyId: 'F10001',
    name: 'Anti-aging 10% nano VIT C',
    path: 'Anti-aging com Nano up-lift',
    oldValue: 99.9,
    showCart: true,
    hidePriceCart: false,
    value: 39.9,
    discountPercent: 60,
    category: ProductCategory.SKIN,
    image: '/assets/img/cart-images/anti-aging-fundo-produto.jpg',
    slug: 'anti-aging',
    numericSlug: undefined,
    rightDescription: 'Aquelas "famosas" marcas de expressão já estão começando a te incomodar?\n\nPensando nisso, desenvolvemos um anti-aging que não só reduz e previne as linhas de expressão, mas também deixa sua pele mais firme, macia e hidratada, dando a você um aspecto mais jovem e saudável. Com textura leve, é rapidamente absorvido, dando um efeito lifting no seu rosto.',
    rightDescriptionBold: 'O seu "eu" do futuro irá nos agradecer!',
    description: {
      title: 'O que é o anti-aging?',
      text: 'Um poderoso creme anti-idade que reduz os sinais de envelhecimento e diminui as linhas de expressão que surgem a partir dos 25 anos de idade.<br /><br /><strong>Com eficácia comprovada e 95% de aprovação nos testes em laboratório</strong>, nosso anti-aging corrige as marcas já existentes e previne o surgimento de novas. Fácil e prático de passar, é composto por 10% de Nano Vitamina C, Vitamina E, Ácido Hialurônico e Nano Up Lift. Juntos resultam em um produto excepcional que estimula a produção de colágeno, deixando a pele mais firme e macia, com textura uniforme e a tonalidade mais homogênea.',
    },
    rating: '4.9',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/anti-aging-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-anti-aging-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/anti-aging-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-anti-aging-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/anti-aging-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-anti-aging-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/anti-aging-1.png',
        text: 'Reduz as linhas de expressão',
      },
      {
        icon: '/assets/img/product-page-advantages/anti-aging-2.png',
        text: 'Pele firme e macia',
      },
      {
        icon: '/assets/img/product-page-advantages/anti-aging-3.png',
        text: 'Produção de colágeno',
      },
      {
        icon: '/assets/img/product-page-advantages/anti-aging-4.png',
        text: 'Aprovada no teste de eficácia',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/anti-aging.png',
      imageMobile: '/assets/img/product-page-who-uses/anti-aging-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★★',
          text: 'Nossa incrivel o cheiro! Eu uso todos os dias e é um ótimo pós barba, fica dica ai rs',
          name: 'Emílio F. - Brasília',
        },
        {
          stars: '★★★★★',
          text: 'Rejuvenesce mesmo. Uso todos os dias e mais ainda depois de pegar uma onda.',
          name: 'Victor C. - Rio de Janeiro',
        },
        {
          stars: '★★★★☆',
          text: 'Achei que após os 50 nada funcionaria, leve engano kk. Esse creme me surpreendeu e olha que já usei outros!',
          name: 'Maurício M. - São Paulo',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/anti-aging.jpg',
      bannerMobile: '/assets/img/product-page-questions/anti-aging.png',
      questions: [
        {
          name: 'O que é?',
          description: '<p>Um creme anti idade com fórmula exclusiva que rejuvenesce e hidrata a pele facial masculina</p>Composição: 10% de Nano VIT C, Ácido Hialurônico, Nano Uplift, Acácia do Senegal e Vitamina E',
        },
        {
          name: 'Como age?',
          description: 'Penetrando nas camadas mais profundas da pele facial, estimula a produção de colágeno, combate os radicais livres e promove uma hidratação completa da pele.',
        },
        {
          name: 'O que esperar?',
          description: 'Após 28 dias de uso, espera-se uma redução significativa das linhas de estresse, cansaço e expressão, o afinamento do bigode chinês e o aumento da elasticidade da pele.',
        },
      ],
    },
    productInfo: {
      type: 'PELE',
      unity: '30ml',
      duration: 'TESTE DE EFICÁCIA',
      hideUnity: true,
      hideLabel: true,
      text: [ '<p>Um surpreendente creme rejuvenescedor, que além de hidratar a pele, reduz os sinais de cansaço e linhas de estresse, bem como o bigode chinês.</p> Com <a href="https://themens-terms.s3-sa-east-1.amazonaws.com/estudo-de-eficacia-anti-aging-the-mens.pdf"  target="_blank"><u>eficácia comprovada</u></a> e 95% de aprovação nos testes em laboratório.' ],
      subText: '<a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/anti-aging.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/anti-aging-1.jpg',
        title: '95% de aprovação',
        text: 'O único creme anti idade com <u><a href="https://themens-terms.s3-sa-east-1.amazonaws.com/estudo-de-eficacia-anti-aging-the-mens.pdf" target="_blank">95% de aprovação em laboratório</a></u> após inumeros testes realizados. Os resultados são surpreendentes!'
      },
      {
        image: '/assets/img/product-page-about/anti-aging-2.jpg',
        title: 'Absorção rápida',
        text: 'Fórmula única e exclusiva que mais parece gel, ele é rapidamente absorvido e não deixa a pele oleosa. Passou, secou.'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-anti-aging-1.png',
      '/assets/img/products-images/the-mens-anti-aging-2.png',
      '/assets/img/cart-images/anti-aging-fundo-produto.jpg',
    ],
    descriptionImage: '/assets/img/products-images/the-mens-anti-aging-desc.jpg',
    amounts: [
      {
        value: 30,
        label: 'ml',
      },
    ],
    infos: {
      left: [
        {
          title: 'Nano vitamina C',
          description: 'Antioxidante que aliado a nanotecnologia,\npotencializa seus efeitos, promove uma\nação firmadora e auxilia o estímulo da\nprodução de colágeno.',
        },
        {
          title: 'Vitamina E',
          description: 'Possui efeito rejuvenescedor.\nAtua combatendo os radicais livres que\nsão os responsáveis pela formação de\nlinhas de expressão, manchas e rugas.',
        },
      ],
      right: [
        {
          title: 'Nano up lift',
          description: 'Extremamente importante para a manutenção\ne desenvolvimento da epiderme, pois atua na\nprodução de colágeno e queratina.\n\n',
        },
        {
          title: 'Ácido hialurônico',
          description: 'Ajuda a manter a hidratação e sustentação da pele,\nevitando a flacidez. Promove uma intensa\nrevitalização, reduzindo as linhas de expressão e\ndeixando a pele mais hidratada e macia.',
        },
      ],
    },
    faq: [
      {
        title: 'Como devo usar?',
        description: 'Com a pele limpa, aplique o Anti-aging da The Men\'s massageando até ser totalmente absorvido. Sugestão: use logo após o banho.\n',
      },
      {
        title: 'Devo utilizar protetor solar após aplicar o anti-aging?',
        description: 'Para uma pele mais jovem e saudável recomendamos o uso de protetor solar, pois ajudará a protegê-la da exposição ao sol.',
      },
      {
        title: 'Tem efeito em todos os tipos de pele?',
        description: 'Sim. Se usado de forma correta e seguindo todas as indicações, o resultado do tratamento terá o mesmo efeito em todas as peles.',
      },
      {
        title: 'Quantas vezes ao dia devo passar?',
        description: 'Recomenda-se utilizar 2 pumps ao dia. O segredo para uma pele jovem é o uso contínuo do produto.',
      },
      {
        title: 'Onde encontro o teste de eficácia?',
        description: 'Nosso teste de eficácia pode ser encontrado <a href="https://themens-terms.s3-sa-east-1.amazonaws.com/estudo-de-eficacia-anti-aging-the-mens.pdf" target="_blank" rel="noreferrer noopener">aqui</a>.',
      },
      {
        title: 'Em quanto tempo irei perceber os resultados?',
        description: 'Logo nos primeiros dias você perceberá sua pele mais jovem, hidratada e macia. Dentro de 28 dias, resultados mais intensos já são notados por nossos usuários.',
      },
      {
        title: 'Qual PH do Anti-Aging da The Men\'s?',
        description: 'Nosso produto tem PH entre 3.0 - 4.0.',
      },
      {
        title: 'É fácil de utilizar ? Deixa a pele oleosa?',
        description: 'Sim, é fácil de passar e espalhar. Em nossos testes, 95% dos participantes afirmaram que foi fácil de aplicar e espalhar o produto sobre a pele; 90% afirmaram que o produto foi absorvido rapidamente pela pele (secou rápido) e que não deixou a pele oleosa.',
      },
    ],
  },
  {
    code: 19,
    id: 'bb1db63f-4a7b-4925-b1ee-94f47d3f5d1c',
    tinyId: 'F10001',
    name: 'Anti-aging 10% nano VIT C',
    path: 'Anti-aging com Nano up-lift',
    oldValue: 99.9,
    showCart: true,
    hidePriceCart: false,
    value: 84.91,
    discountPercent: 15.8,
    category: ProductCategory.SKIN,
    image: '/assets/img/cart-images/anti-aging-fundo-produto.jpg',
    slug: 'anti-aging',
    numericSlug: undefined,
    rightDescription: 'Aquelas "famosas" marcas de expressão já estão começando a te incomodar?\n\nPensando nisso, desenvolvemos um anti-aging que não só reduz e previne as linhas de expressão, mas também deixa sua pele mais firme, macia e hidratada, dando a você um aspecto mais jovem e saudável. Com textura leve, é rapidamente absorvido, dando um efeito lifting no seu rosto.',
    rightDescriptionBold: 'O seu "eu" do futuro irá nos agradecer!',
    description: {
      title: 'O que é o anti-aging?',
      text: 'Um poderoso creme anti-idade que reduz os sinais de envelhecimento e diminui as linhas de expressão que surgem a partir dos 25 anos de idade.<br /><br /><strong>Com eficácia comprovada e 95% de aprovação nos testes em laboratório</strong>, nosso anti-aging corrige as marcas já existentes e previne o surgimento de novas. Fácil e prático de passar, é composto por 10% de Nano Vitamina C, Vitamina E, Ácido Hialurônico e Nano Up Lift. Juntos resultam em um produto excepcional que estimula a produção de colágeno, deixando a pele mais firme e macia, com textura uniforme e a tonalidade mais homogênea.',
    },
    rating: '4.9',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/anti-aging-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-anti-aging-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/anti-aging-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-anti-aging-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/anti-aging-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-anti-aging-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/anti-aging-1.png',
        text: 'Reduz as linhas de expressão',
      },
      {
        icon: '/assets/img/product-page-advantages/anti-aging-2.png',
        text: 'Pele firme e macia',
      },
      {
        icon: '/assets/img/product-page-advantages/anti-aging-3.png',
        text: 'Produção de colágeno',
      },
      {
        icon: '/assets/img/product-page-advantages/anti-aging-4.png',
        text: 'Aprovada no teste de eficácia',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/anti-aging.png',
      imageMobile: '/assets/img/product-page-who-uses/anti-aging-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★★',
          text: 'Nossa incrivel o cheiro! Eu uso todos os dias e é um ótimo pós barba, fica dica ai rs',
          name: 'Emílio F. - Brasília',
        },
        {
          stars: '★★★★★',
          text: 'Rejuvenesce mesmo. Uso todos os dias e mais ainda depois de pegar uma onda.',
          name: 'Victor C. - Rio de Janeiro',
        },
        {
          stars: '★★★★☆',
          text: 'Achei que após os 50 nada funcionaria, leve engano kk. Esse creme me surpreendeu e olha que já usei outros!',
          name: 'Maurício M. - São Paulo',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/anti-aging.jpg',
      bannerMobile: '/assets/img/product-page-questions/anti-aging.png',
      questions: [
        {
          name: 'O que é?',
          description: '<p>Um creme anti idade com fórmula exclusiva que rejuvenesce e hidrata a pele facial masculina</p>Composição: 10% de Nano VIT C, Ácido Hialurônico, Nano Uplift, Acácia do Senegal e Vitamina E',
        },
        {
          name: 'Como age?',
          description: 'Penetrando nas camadas mais profundas da pele facial, estimula a produção de colágeno, combate os radicais livres e promove uma hidratação completa da pele.',
        },
        {
          name: 'O que esperar?',
          description: 'Após 28 dias de uso, espera-se uma redução significativa das linhas de estresse, cansaço e expressão, o afinamento do bigode chinês e o aumento da elasticidade da pele.',
        },
      ],
    },
    productInfo: {
      type: 'PELE',
      unity: '30ml',
      duration: 'TESTE DE EFICÁCIA',
      hideUnity: true,
      hideLabel: true,
      text: [ '<p>Um surpreendente creme rejuvenescedor, que além de hidratar a pele, reduz os sinais de cansaço e linhas de estresse, bem como o bigode chinês.</p> Com <a href="https://themens-terms.s3-sa-east-1.amazonaws.com/estudo-de-eficacia-anti-aging-the-mens.pdf"  target="_blank"><u>eficácia comprovada</u></a> e 95% de aprovação nos testes em laboratório.' ],
      subText: '<a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/anti-aging.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/anti-aging-1.jpg',
        title: '95% de aprovação',
        text: 'O único creme anti idade com <u><a href="https://themens-terms.s3-sa-east-1.amazonaws.com/estudo-de-eficacia-anti-aging-the-mens.pdf" target="_blank">95% de aprovação em laboratório</a></u> após inumeros testes realizados. Os resultados são surpreendentes!'
      },
      {
        image: '/assets/img/product-page-about/anti-aging-2.jpg',
        title: 'Absorção rápida',
        text: 'Fórmula única e exclusiva que mais parece gel, ele é rapidamente absorvido e não deixa a pele oleosa. Passou, secou.'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-anti-aging-1.png',
      '/assets/img/products-images/the-mens-anti-aging-2.png',
      '/assets/img/cart-images/anti-aging-fundo-produto.jpg',
    ],
    descriptionImage: '/assets/img/products-images/the-mens-anti-aging-desc.jpg',
    amounts: [
      {
        value: 30,
        label: 'ml',
      },
    ],
    infos: {
      left: [
        {
          title: 'Nano vitamina C',
          description: 'Antioxidante que aliado a nanotecnologia,\npotencializa seus efeitos, promove uma\nação firmadora e auxilia o estímulo da\nprodução de colágeno.',
        },
        {
          title: 'Vitamina E',
          description: 'Possui efeito rejuvenescedor.\nAtua combatendo os radicais livres que\nsão os responsáveis pela formação de\nlinhas de expressão, manchas e rugas.',
        },
      ],
      right: [
        {
          title: 'Nano up lift',
          description: 'Extremamente importante para a manutenção\ne desenvolvimento da epiderme, pois atua na\nprodução de colágeno e queratina.\n\n',
        },
        {
          title: 'Ácido hialurônico',
          description: 'Ajuda a manter a hidratação e sustentação da pele,\nevitando a flacidez. Promove uma intensa\nrevitalização, reduzindo as linhas de expressão e\ndeixando a pele mais hidratada e macia.',
        },
      ],
    },
    faq: [
      {
        title: 'Como devo usar?',
        description: 'Com a pele limpa, aplique o Anti-aging da The Men\'s massageando até ser totalmente absorvido. Sugestão: use logo após o banho.\n',
      },
      {
        title: 'Devo utilizar protetor solar após aplicar o anti-aging?',
        description: 'Para uma pele mais jovem e saudável recomendamos o uso de protetor solar, pois ajudará a protegê-la da exposição ao sol.',
      },
      {
        title: 'Tem efeito em todos os tipos de pele?',
        description: 'Sim. Se usado de forma correta e seguindo todas as indicações, o resultado do tratamento terá o mesmo efeito em todas as peles.',
      },
      {
        title: 'Quantas vezes ao dia devo passar?',
        description: 'Recomenda-se utilizar 2 pumps ao dia. O segredo para uma pele jovem é o uso contínuo do produto.',
      },
      {
        title: 'Onde encontro o teste de eficácia?',
        description: 'Nosso teste de eficácia pode ser encontrado <a href="https://themens-terms.s3-sa-east-1.amazonaws.com/estudo-de-eficacia-anti-aging-the-mens.pdf" target="_blank" rel="noreferrer noopener">aqui</a>.',
      },
      {
        title: 'Em quanto tempo irei perceber os resultados?',
        description: 'Logo nos primeiros dias você perceberá sua pele mais jovem, hidratada e macia. Dentro de 28 dias, resultados mais intensos já são notados por nossos usuários.',
      },
      {
        title: 'Qual PH do Anti-Aging da The Men\'s?',
        description: 'Nosso produto tem PH entre 3.0 - 4.0.',
      },
      {
        title: 'É fácil de utilizar ? Deixa a pele oleosa?',
        description: 'Sim, é fácil de passar e espalhar. Em nossos testes, 95% dos participantes afirmaram que foi fácil de aplicar e espalhar o produto sobre a pele; 90% afirmaram que o produto foi absorvido rapidamente pela pele (secou rápido) e que não deixou a pele oleosa.',
      },
    ],
  },
  {
    code: 20,
    id: '38b60b58-235c-4e79-9ddf-d91e784e7a1c',
    tinyId: 'F10008',
    name: 'Tônico para barba',
    path: 'Tônico com Auxina Tricógena®',
    showCart: true,
    hidePriceCart: false,
    value: 55.16,
    oldValue: 64.9,
    discountPercent: 22,
    category: ProductCategory.BEARD,
    image: '/assets/img/cart-images/tonico-fundo-produto.jpg',
    slug: 'tonico-para-barba',
    numericSlug: undefined,
    rating: '4.7',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/tonico-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-tonico-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/tonico-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-tonico-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/tonico-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-tonico-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/tonico-1.png',
        text: '4x mais fortes que outras',
      },
      {
        icon: '/assets/img/product-page-advantages/tonico-2.png',
        text: 'Crescimento capilar',
      },
      {
        icon: '/assets/img/product-page-advantages/tonico-3.png',
        text: 'Zero açúcar',
      },
      {
        icon: '/assets/img/product-page-advantages/tonico-4.png',
        text: 'Fortacele a imunidade',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/tonico.png',
      imageMobile: '/assets/img/product-page-who-uses/tonico-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★★',
          text: 'Aonde já se viu japonês com barba? Achei que nunca ia ter até usar o tônico!',
          name: 'Rodrigo G. - São Paulo',
        },
        {
          stars: '★★★★★',
          text: 'Muito cheiroso e gostoso de passar. Super recomendo!',
          name: 'Cesar Cielo - Santa Catarina',
        },
        {
          stars: '★★★★☆',
          text: 'Não acreditava mas após 5 meses de uso estou super barbudo e confiante!',
          name: 'Glauco R. - São Paulo',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/tonico.jpg',
      bannerMobile: '/assets/img/product-page-questions/tonico-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: '<p>Um blend de poderosos ativos, com tecnologia patenteada e comprovação científica para estimular o crescimento da barba e acelerar a formação de novos fios.</p> Composição: 15% de Auxina Tricógena, H-VIT©, Biotina, mentol, Arginina e Fito extratos tonificantes.',
        },
        {
          name: 'Como age?',
          description: 'Atingindo as camadas mais profundas da pele do rosto, aumenta a circulação sanguínea, propiciando que mais nutrientes cheguem ao local. Ainda, estimula as células capilares para que você tenha um crescimento mais rápido e duradouro da barba.',
        },
        {
          name: 'O que esperar?',
          description: '<p>Ao longo dos meses* de utilização diária, espera-se uma significativa redução da oleosidade, um aumento relevante da densidade e quantidade dos fios e o fechamento das falhas na barba</p> *Recomenda-se o uso por no mínimo 3 meses consecutivos',
        },
      ],
    },
    productInfo: {
      type: 'QUEDA DE CABELO',
      unity: '30unid',
      duration: '1 MÊS',
      hideUnity: true,
      hideLabel: false,
      text: [ '<p>Um tônico com alta tecnologia para você fechar as falhas e ter mais barba.</p> O único com 15% de Auxina Tricógena© e H-VIT©, mais forte e efeito eterno Aprovado pela Anvisa.' ],

      subText: '<a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/tonico.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/tonico-1.jpg',
        title: 'Eficácia comprovada',
        text: 'Com tecnologia patenteada e testes clínicos realizados em laboratórios verificou-se um nítidos crescimento dos fios e um fechamento das falhas.'
      },
      {
        image: '/assets/img/product-page-about/tonico-2.jpg',
        title: 'Resultados eternos',
        text: 'Após o alcance dos resultados obtidos, não é necessário utilizar mais o tônico, pois sua barba continuara crescendo.'
      },
      {
        image: '/assets/img/product-page-about/tonico-3.jpg',
        title: 'Absorção mais rápida',
        text: 'Com uma fórmula exclusiva feita para ser rapidamente absorvida e dimunuir a oleosidade, nosso tônico entrega resultados surpreendentes sem deixar a pele oleosa.'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-tonico-para-barba-1.png',
      '/assets/img/products-images/the-mens-tonico-para-barba-2.png',
      '/assets/img/cart-images/tonico-fundo-produto.jpg',
    ],
    rightDescription: 'Já pode separar seu barbeador porque com o nosso Tônico você vai usar ele mais vezes do que imagina!<br /><br />Desenvolvido para estimular o crescimento saudável dos fios e auxiliar a combater a queda. Tenha mais volume e feche as falhas.<br /><br /><strong>Sua barba vai crescer como nunca cresceu!</strong>',
    description: {
      title: 'O que é o tônico para a barba?',
      text: 'É um blend de ativos que auxiliam no crescimento da barba, aumentando o volume e fechando as falhas.<br /><br />Com uma composição rica de aminoácidos e vitaminas, promove o crescimento acelerado do pelo, gera uma ação protetora e controla a oleosidade excessiva. Seus ativos irão preencher sua barba e aumentar o volume, além de deixar os fios mais brilhosos e saudáveis. Livre de parabenos.',
    },
    descriptionImage: '/assets/img/products-images/the-mens-tonico-para-barba-desc-new.jpg',
    amounts: [
      {
        value: 30,
        label: 'ml',
      },
    ],
    infos: {
      left: [
        {
          title: 'Auxina Tricogena ®',
          description: 'Com eficácia comprovada, auxilia no crescimento\ne fortalecimento dos fios. Age melhorando o\ntrofismo do pelo na fase anágena ao mesmo\ntempo em que diminui a fase telógena.',
        },
        {
          title: 'Biotina',
          description: 'Auxilia na formação de queratina, protegendo\na estrutura da haste dos pelos. Além disso,\nmantém a região hidratada e ajuda\nno crescimento saudável dos fios.',
        },
        {
          title: 'Mentol',
          description: 'Com ação refrescante, auxilia o crescimento\nda barba, reduz o excesso de oleosidade da\npele e evita a queda dos pelos.',
        },
      ],
      right: [
        {
          title: 'H-Vit ®',
          description: 'Ativo multifuncional que controla a oleosidade\ndo local onde foi utilizado. Além disso,\npromove a restauração da barreira cutânea e\nfortalece o bulbo, auxiliando na prevenção da queda.',
        },
        {
          title: 'Fito extratos tonificantes',
          description: 'Promove ações tonificantes, antisséptica,\ncicatrizante, protetora, hidratante, regeneradora e\natravés dos derivados da celulose.\n\n',
        },
        {
          title: 'Arginina',
          description: 'Aminoácido essencial que compõe a fibra capilar.\nPromove o crescimento dos fios e cria uma película\nque fecha as escamas dos pelos, fortalecendo-os e\ndiminuindo a queda e a quebra.',
        },
      ],
    },
    faq: [
      {
        title: 'Como devo utilizá-lo?',
        description: 'Agite antes de usar. Sobre a pele limpa, aplique uma pequena quantidade com a ponta dos dedos massageando bem sobre a pele até sua absorção. Deixe secar naturalmente.',
      },
      {
        title: 'Quantas vezes ao dia devo passar?',
        description: 'Para resultados mais intensos, recomenda-se o uso 2x ao dia. Não lave o local de aplicação por 3h. ',
      },
      {
        title: 'Pode ser usado em todos os tipos de pele? ',
        description: 'Sim! Nosso tônico pode ser utilizado em todos os tipos de pele.',
      },
      {
        title: 'Em quanto tempo vejo o resultado?',
        description: 'A partir do 2º mês, você já começa a perceber uma barba um pouco mais volumosa e as falhas diminuindo. Contudo, a partir do 3º mês, os resultados são mais notórios.',
      },
      {
        title: 'Posso usar todos os dias?',
        description: 'Deve. O uso diário é essencial para um tratamento adequado e satisfatório. ',
      },
      {
        title: 'Engrossa meu pelo? ',
        description: 'Sim, com o uso do tônico, os pelos ralos e frágeis serão fortalecidos.',
      },
    ],
  },
  {
    code: 21,
    id: 'f3f2ee08-d53f-471e-8a50-e1ea0cff86f6',
    tinyId: 'F10005',
    name: 'Vita gummy',
    path: 'Vita gummy',
    showCart: false,
    hidePriceCart: false,
    value: 26.9,
    oldValue: 66.3,
    tagPromotion: 'Promoção',
    category: ProductCategory.HAIR,
    image: '/assets/img/cart-images/nova-vita-gummy-fundo-produto.jpg',
    slug: 'gummy',
    numericSlug: undefined,
    rating: '4.9',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/gummy-1.png',
        mini: '/assets/img/product-page-carousel/mini-gummy-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/gummy-2.png',
        mini: '/assets/img/product-page-carousel/mini-gummy-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/gummy-3.png',
        mini: '/assets/img/product-page-carousel/mini-gummy-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/gummy-1.png',
        text: '4x mais fortes que outras',
      },
      {
        icon: '/assets/img/product-page-advantages/gummy-2.png',
        text: 'Crescimento capilar',
      },
      {
        icon: '/assets/img/product-page-advantages/gummy-3.png',
        text: 'Zero açúcar',
      },
      {
        icon: '/assets/img/product-page-advantages/gummy-4.png',
        text: 'Fortacele a imunidade',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/gummy.png',
      imageMobile: '/assets/img/product-page-who-uses/gummy-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★★',
          text: 'Sinto meus cabelos mais fortes e volumosos. Dificil é comer só uma gummy',
          name: 'Tiago N. - São Paulo',
        },
        {
          stars: '★★★★★',
          text: 'Junto com o tônico, acelerou demais o crescimento da minha barba',
          name: 'Rodrigo I. - São Paulo',
        },
        {
          stars: '★★★★★',
          text: 'O melhor polivitaminico que eu já tomei!!',
          name: 'Gorgonoid. - Minas Gerais',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/gummy.png',
      bannerMobile: '/assets/img/product-page-questions/gummy-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: '<p>Bala de gelatina com 11 nutrientes nutrientes necessários para seu cabelo crescer mais rápido e mais forte.</p> Composição: Vitamina A (1.200mcg), Vitamina B5 (5mg), Biotina (45mcg), Vitamina B9 (667mcg), Vitamina B12 (8mcg), Vitamina C (60mg), Vitamina D (19mcg), Vitamina E (10mg), Iodo (80mcg) e Zinco (7mg)',
        },
        {
          name: 'Como age?',
          description: 'Suprindo todas as necessidades diárias de vitaminas e minerais para que o crescimento e fortalecimento do cabelo se dê em sua máxima performance.',
        },
        {
          name: 'O que esperar?',
          description: 'Uma suplementação completa de vitaminas e minerais que te auxilia a ter um crescimento capilar (cabelo e barba) mais rápido e saudavel e uma imunidade mais forte.',
        },
      ],
    },
    productInfo: {
      type: 'QUEDA DE CABELO',
      unity: '30unid',
      duration: '1 MÊS',
      hideUnity: true,
      hideLabel: false,
      text: [ 'Nossa vita gummy contém todos os nutrientes e vitaminas que você precisa para ter mais vitalidade, mais cabelos e imunidade.' ],
      subText: '<a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/gummy.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/gummy-1.png',
        title: 'Composição perfeita',
        text: 'Boost de nutrientes e minerais especialmente calculados e selecionados para um efeito 4x mais forte e prolongado'
      },
      {
        image: '/assets/img/product-page-about/gummy-2.png',
        title: 'Zero açúcar',
        text: 'Pensando na sua saúde, desenvolvemos uma gelatina que não contenha açúcar, não afetando sua dieta e promovendo uma qualidade de vida'
      },
      {
        image: '/assets/img/product-page-about/gummy-3.png',
        title: 'Deliciosa',
        text: 'Com um sabor gostoso, você se nutre sem perceber. Dificil será comer somente uma hmm...'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-gummy-1.png',
      '/assets/img/products-images/vita-gummy.png',
      '/assets/img/cart-images/nova-vita-gummy-fundo-produto.jpg',
    ],
    rightDescription: 'Desenvolvida especialmente para você, com um delicioso sabor de maçã verde e zero açúcar. Nossa vita gummy contém todos os nutrientes necessários para fortalecer seu cabelo, pele e unhas. <strong>Duvido comer só uma!</strong>',
    description: {
      title: 'O que é a vitma gummy?',
      text: 'Nossa vita gummy é um suplemento alimentar, feito à base de gelatina, com nutrientes essenciais para o crescimento capilar. Zero açúcar, contêm em sua formulação um alto teor de B7 (Biotina), B9 (Ácido fólico), B5 (Ácido Pantotênico) vitaminas A, B12, C, D, zinco entre outras. Ela previne a queda capilar e a calvície, além de auxiliar no funcionamento do sistema imune.',
    },
    descriptionImage: '/assets/img/products-images/the-mens-gummy-desc.jpg',
    amounts: [
      {
        value: 105,
        label: 'g',
      },
      {
        value: 30,
        label: 'unidades',
      },
    ],
    infos: {
      left: [
        {
          title: 'Biotina',
          description: 'Essencial para a saúde dos cabelos,\npele, unhas, contríbui na produção\nde queratina pelo corpo humano.',
        },
        {
          title: 'Ácido Fólico',
          description: 'Estimula o crescimento dos cabelos e\ndas unhas, controla a oleosidade e\ncombate a acne e a dermatite, deixando\no cabelo com mais brilho.',
        },
        {
          title: 'Zinco',
          description: 'Reduz a queda de cabelo,\nauxilia no tratamento da acne e\nna cicatrização de feridas.',
        },
      ],
      right: [
        {
          title: 'Vitamina A',
          description: 'Extremamente importante para a manutenção e\ndesenvolvimento do tecido capilar, pois atua na\nprodução de colágeno e queratina.',
        },
        {
          title: 'Vitamina C',
          description: 'É um poderoso antioxidante, que auxilia na formação\nde colágeno e protege os fios, deixando as hastes\ncapilares mais fortes; e previne a descamação e\nirritação do couro cabeludo.',
        },
        {
          title: 'Vitamina D',
          description: 'Ajuda na recuperação de estrutura capilar\ne no funcionamento muscular e é\nessencial para o nosso sistema imune.',
        },
      ],
    },
    faq: [
      {
        title: 'Do que é feita a vita gummy?',
        description: 'Um produto saboroso, zero açúcar, feito à base de gelatina e pectina vegetal cheio de vitaminas. As gummies contêm B7 (Biotina), B9 (Ácido fólico), B5 (Ácido Pantotênico) vitaminas A, B12, C, D, zinco e Iodo.',
      },
      {
        title: 'Quantas gummies posso comer por dia?',
        description: 'É indicado consumir  apenas uma vita gummy ao dia ou conforme orientação médica.',
      },
      {
        title: 'Existe alguma contraindicação?',
        description: 'Nossa vita gummy é contraindicada para gestantes, lactantes e crianças.',
      },
      {
        title: 'A vita gummy engorda?',
        description: 'Acredite, você queima 1 vita gummy com apenas um copo de água gelada.',
      },
      {
        title: 'A vita gummy é indicada para todos os tipos de cabelo?',
        description: 'Sim, as vitaminas funcionam para todos os tipos de cabelo, agindo de dentro para fora dos fios.',
      },
      {
        title: 'Quando vou ver os resultados?',
        description: 'Para que o tratamento seja eficaz, recomendamos o uso de nossas gummies por 3 meses, porém os resultados variam de acordo com o estilo de vida e metabolismo de cada pessoa. Para um melhor resultado, recomendamos nosso hair kit.',
      },
    ],
  },
  {
    code: 22,
    id: '27d86cbd-419b-474b-9503-454340ab5800',
    tinyId: 'F10002',
    name: 'Chá Daily Boost',
    path: 'Chá Energizante',
    showCart: true,
    hidePriceCart: false,
    value: 58.56,
    oldValue: 68.9,
    category: ProductCategory.HEALTH,
    image: '/assets/img/cart-images/daily-boost-fundo-produto.jpg',
    slug: 'cha-do-dia-fora-de-estoque',
    numericSlug: undefined,
    rating: '5.0',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/cha-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-cha-1.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/cha-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-cha-2.jpg',
      },
      {
        banner: '/assets/img/product-page-carousel/cha-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-cha-3.jpg',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/cha-1.png',
        text: '4x mais fortes que outras',
      },
      {
        icon: '/assets/img/product-page-advantages/cha-2.png',
        text: 'Crescimento capilar',
      },
      {
        icon: '/assets/img/product-page-advantages/cha-3.png',
        text: 'Zero açúcar',
      },
      {
        icon: '/assets/img/product-page-advantages/cha-4.png',
        text: 'Fortacele a imunidade',
      },
      {
        icon: '/assets/img/product-page-advantages/cha-5.png',
        text: 'Fortacele a imunidade',
      },
    ],
    whoUses: {
      image: '/assets/img/product-page-who-uses/cha.png',
      imageMobile: '/assets/img/product-page-who-uses/cha-mobile.png',
    },
    depoiments: {
      title: 'Depoimentos',
      ratings: [
        {
          stars: '★★★★★',
          text: 'Realmente um produto diferenciado. Tomei e senti um calor logo em seguida, tenho muito mais energia.',
          name: 'Carlos B. - São Paulo',
        },
        {
          stars: '★★★★★',
          text: 'Substituí pelo café antes dos meus treinos. Estou gostando bastante do resultado',
          name: 'Cesar C. - Porto Alegre',
        },
        {
          stars: '★★★★☆',
          text: 'Tem ação diurética forte, volto do fds inchado, tomo ele e pronto! Além disso, cura ressaca kkkk',
          name: 'Lucas H. - Rio de Janeiro',
        },
      ]
    },
    commonQuestions: {
      banner: '/assets/img/product-page-questions/cha.png',
      bannerMobile: '/assets/img/product-page-questions/cha-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: 'Uma bebida leve e estimulante, composta por 12 ervas pré selecionadas com efeitos significativos no corpo humano.',
        },
        {
          name: 'Como age?',
          description: 'Ao ingerirmos esse super chá, nosso corpo absorve os nutrientes existentes nas ervas. Esses ativos aceleram nosso metabolismo, aumenta a diurese e cessa a fome.',
        },
        {
          name: 'O que esperar?',
          description: 'Maior rendimento nos treinos, diminuição do inchaço, maior foco e energia, e diminuição do apetite.',
        },
      ],
    },
    productInfo: {
      type: 'QUEDA DE CABELO',
      unity: '30unid',
      duration: '1 MÊS',
      hideUnity: true,
      hideLabel: false,
      text: [ 'É uma bebida estimulante, que te dá energia e te ajuda a secar. Tenha mais energia a qualquer hora do dia sem manchar os dentes.' ],
      subText: '<a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/cha.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/cha-1.jpg',
        title: 'Alto rendimento',
        text: 'Utilizado por atletas de alta performance, nosso chá tem compostos que te dão um up sem cafeína adicionada, ajudando você a performar melhor.'
      },
      {
        image: '/assets/img/product-page-about/cha-2.jpg',
        title: 'Maior foco e energia',
        text: 'Substitua seu café por essa bebida mágica que vai te deixar mais concentrado e com foco para as atividades do dia a dia. Tenha um desempenho melhor, sem depender da cafeína.'
      },
      {
        image: '/assets/img/product-page-about/cha-3.jpg',
        title: 'Eliminação do inchaço',
        text: 'Exagerou no final de semana? Essa bebida é perfeita para eliminar aquele inchaço adicional e perder peso. Auxilia ainda na queima de gordura corporal.'
      },
    ],
    images: [
      '/assets/img/products-images/the-mens-cha-1.png',
      '/assets/img/products-images/the-mens-cha-2.png',
      '/assets/img/cart-images/daily-boost-fundo-produto.jpg',
    ],
    rightDescription: '<strong>DAILY BOOST</strong>\nSelecionamos as melhores ervas para criarmos uma bebida única, leve e saudável. Tenha mais energia a qualquer hora do dia sem manchar os dentes.',
    rightDescriptionBold: 'Dê um up no seu dia!',
    description: {
      title: 'O que é chá do dia | Daily boost?',
      text: 'É uma bebida estimulante, que te dá energia e te ajuda a secar. Desenvolvida por um time de especialistas, as ervas foram selecionadas cuidadosamente até encontrarmos uma bebida leve, gostosa e energizante.<br /><br />Nossa fórmula, perfeita, contém um misto de mate verde, chá verde, carqueja, hibisco, chá preto e guaraná com canela, gengibre, alecrim, sálvia, cravo e pimenta preta, com leve aroma de abacaxi.<br /><br /><strong>Experimente e surpreenda-se!</strong>',
    },

    descriptionImage: '/assets/img/products-images/the-mens-cha-desc.jpg',
    amounts: [
      {
        value: 60,
        label: 'sachês',
      },
    ],
    infos: {
      left: [
        {
          title: 'Mate Verde',
          description: 'Acelera o metabolismo, proporcionando\nmaior energia e foco. Possui efeito\ndiurético auxiliando na perda de peso.\n\n',
        },
        {
          title: 'Hibisco',
          description: 'Um anti-inflamatório e antioxidante que\ncontribuí para que menos gordura fique\nacumulada na região do abdômen e evita\na retenção de líquidos.',
        },
        {
          title: 'Gengibre',
          description: 'Rico em substâncias termogênicas que\npotencializam a queima de gordura corporal e\najudam a ter mais foco e energia.',
        },
      ],
      right: [
        {
          title: 'Chá Preto',
          description: 'Estimulante que garante energia, diminuição do\ncansaço e da sonolência ao longo do dia.\nAuxilia na queima de gordura e na redução do\napetite devido às substâncias antioxidantes.',
        },
        {
          title: 'Guaraná',
          description: 'Energizante que auxilia na circulação sanguínea,\npropiciando um maior rendimento e disposição.\nTambém ajuda a eliminar toxinas do organismo\ndevido às propriedades diuréticas.',
        },
        {
          title: 'Pimenta Preta',
          description: 'Com ação termogênica, estimula a produção de\nserotonina, aumentando a sensação de \nbem-estar e melhora na produtividade.',
        },
      ],
    },
    faq: [
      {
        title: 'Qual o modo de preparo? ',
        description: 'Para preparar seu chá, basta seguir as devidas instruções:\n1) Esquente 200ml de água até começar a ferver e desligue o fogo.\n2) Coloque um sachê dentro da água, tampe e espere 3 minutos.\n3) Pronto! Seu chá energizante está pronto para beber.\n\nDica apimentada: Sempre fica um pouco de pozinho no envelope de cada sachê.\nAdicione-o no seu chá e surpreenda-se com o resultado.',
      },
      {
        title: 'Quais os ingredientes?',
        description: 'Com ingredientes cuidadosamente selecionados e um mix variado, nosso chá leva em sua composição: mate verde, chá verde, carqueja, hibisco, chá preto e guaraná com canela, gengibre, alecrim, sálvia, cravo e pimenta preta.',
      },
      {
        title: 'Quantos sachês vêm dentro da caixa? ',
        description: 'Nossa caixa é acompanhada de 60 sachês, sugere-se o uso de 2 sachês ao dia.',
      },
      {
        title: 'Somente homens podem tomar?',
        description: 'Não. Qualquer pessoa pode tomar, independente do sexo biológico.',
      },
      {
        title: 'Posso tomar todos os dias?',
        description: 'Sim, não há contraindicações. Tome à vontade e tenha energia durante todo o seu dia, ou à noite rsrs.',
      },
      {
        title: 'Posso tomar antes de dormir?',
        description: 'Caso vá dormir logo em seguida, não é recomendado sua ingestão, devido às suas propriedades estimulantes.',
      },
      {
        title: 'Posso tomar gelado?',
        description: 'Pode! Contudo, dada às propriedades termogênicas, recomendamos seu uso quente e logo após a infusão.',
      },
      {
        title: 'Posso misturar com outras bebidas?',
        description: 'Não há contraindicações para criar um drink especial. Deu certo? Não deixe de nos contar nas redes sociais.',
      },
    ],
  },
  {
    code: 24,
    id: '312974bf-1dac-434d-8084-942e42beed8b',
    name: 'Tadalaspray',
    path: 'Tadalaspray',
    showCart: true,
    hidePriceCart: true,
    value: 249.9,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: true,
    prescriptionLink: prescriptionType.ed,
    image: '/assets/img/cart-images/tadalaspray-fundo-produto.png',
    defaultCoupon: 'TADALAPROMO2',
    images: [
      '/assets/img/cart-images/tadalaspray-fundo-produto.png',
    ],
    justMen:
    {
      img: '/assets/img/product-page-info/male.png',
    },
    slug: 'tadala-spray',
    numericSlug: '2790109453',
    slugToUse: 'numericSlug',
    rating: '5.0',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/tadala-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-tadala-1.png',
      },
      {
        banner: '/assets/img/product-page-carousel/tadala-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-tadala-2.png',
      },
      {
        banner: '/assets/img/product-page-carousel/tadala-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-tadala-3.png',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/tadala-1.png',
        text: 'Ativos originais e puros',
      },
      {
        icon: '/assets/img/product-page-advantages/tadala-2.png',
        text: 'Prático, em spray. Cabe no bolso.',
      },
      {
        icon: '/assets/img/product-page-advantages/tadala-3.png',
        text: 'Rápida Absorção',
      },
      {
        icon: '/assets/img/product-page-advantages/tadala-4.png',
        text: 'Encurta o intervalo de ereção',
      },
    ],
    commonQuestions: {
      banner: '/assets/img/product-page-questions/tadala.png',
      bannerMobile: '/assets/img/product-page-questions/tadala-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: 'Inovação no mercado sexual, é um spray potente, compacto e discreto tendo como ativo principal um dos mais recomendados no mundo por urologistas.',
        },
        {
          name: 'Como age?',
          description: 'Ao borrifa-lo embaixo da língua (sublingual), é instantaneamente absorvido pelo corpo, vasodilatando as artérias, aumentando o fluxo sanguíneo, auxiliando na promoção  de maior desejo e ereções mais duradouras.',
        },
        {
          name: 'O que esperar?',
          description: 'Aumento do desejo sexual, diminuição do período refratário (tempo de recuperação entre uma ejaculação e outra) e ereções mais vigorosas, apenas quando houver estimulo, e pelo período de 36h.',
        },
      ],
    },
    productInfo: {
      type: 'SAÚDE SEXUAL',
      unity: '10ml',
      duration: '5 MESES',
      hideUnity: true,
      hideLabel: false,
      text: [ 'Spray sexual que auxilia na performance e na evolução da ereção.<br /> Local de aplicação: <b>Sublingual</b><br />Um frasco contém 120 doses de 5mg, totalizando 600mg no total' ],
      subText: 'Venda sob <b>prescrição médica</b> <a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/tadala.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/tadala-1.jpg',
        title: 'Discreto',
        text: 'Com design digno das feiras em milão, cabe no bolso, gostoso ao toque e com sabor incrível. Você leva quando e onde quiser sem questionamentos.'
      },
      {
        image: '/assets/img/product-page-about/tadala-2.jpg',
        title: 'Inovador',
        text: 'Com absorção mais rápida que as pílulas, por ser sublingual, a biodisponibilidade tende a ser maior, potencializando os efeitos.'
      },
      {
        image: '/assets/img/product-page-about/tadala-3.jpg',
        title: 'Único',
        text: 'Com formula exclusiva e desenvolvimento proprietário, é diferente de tudo que já viu, e ainda tem um ótimo custo benefício.'
      },
    ],
    faq: [
      {
        title: 'Posso usar todos os dias? ',
        description: 'Deve-se utilizar de acordo com a prescrição médica. Normalmente, prescreve-se 1 borrifada (5mg) ao dia para tratamentos de incontinência urinária e 4 borrifadas (20mg) para uso sexual',
      },
      {
        title: 'O que acontece se eu exceder a dosagem?',
        description: 'Não é recomendado o uso acima do que foi prescrito. Deite, tome água e procure ajuda médica.',
      },
      {
        title: 'Quem não deve tomar?',
        description: 'Pessoas com questões cardíacas, hipertensas ou que já fizeram uso de tadalafila e não surtiu efeito/tiveram alergia.',
      },
      {
        title: 'O que tem no Tadalaspray?',
        description: 'Tadalaspray é um spray único e inovador contendo um dos ativos mais recomendados pelos médicos para o tratamento da diminuição de desejo e disfunção sexual.',
      },
      {
        title: 'Mulher pode utilizar?',
        description: 'O uso não é recomendado para o sexo biológico feminino. Não há comprovação de aumento de desejo sexual com seu uso, apenas vasodilatação.',
      },
      {
        title: 'Quais são os efeitos colaterais?',
        description: 'Aumento dos batimentos cardíacos, rubor facial, dores de cabeça, dores no corpo poderão ser um dos efeitos colaterais indesejáveis ao utilizar dosagens acima da prescrição.',
      },
      {
        title: 'Vou ficar ereto sempre?',
        description: 'Após utilizar o spray, você ficará ereto apenas se houver estímulo sexual, sendo seguro o uso anterior ao ato sem constrangimento.',
      },
      {
        title: 'Quanto tempo demora para fazer efeito?',
        description: 'Cerca de 30 min após sua utilização, você já conseguirá obter todos os benefícios.',
      },
    ],
    howWorks: {
      title: 'Como o Tadalafila (Cialis) funciona?',
      img: '/assets/img/product-page-carousel/tadala-works.png',
      imgMobile: '/assets/img/product-page-carousel/tadala-works-mobile.png',
    },
    howWorksInfo: [
      {
        title: 'Comunidade Médica',
        text: 'Considerado pelos médicos como um tratamento de primeira linha para solucionar a disfunção erétil, é considerada uma opção muito mais duradoura, eficiente e segura do que o Viagra.',
      },
      {
        title: 'Fluxo sanguíneo',
        text: 'Ao ser absorvida no corpo, inibe a proteína fosfodiesterase tipo 5, aumentando a quantidade de GMPC Cíclico, prolongando as ereções e diminuindo o tempo necessário para ficar ereto novamente',
      },
      {
        title: 'Estimulo sexual',
        text: 'Ela age apenas com estímulo sexual, ou seja, sem o devido estímulo não há ereção involuntária. Assim, não gera constrangimento e aumenta a confiança.',
      }
    ],
    warnings: [ 'Em estudos clínicos, mostrou-se aumentar os efeitos hipotensivos dos nitratos. Supõe-se que isto seja resultado dos efeitos combinados dos nitratos e do princípio ativo na via óxido nítrico/GMPc. Portanto, a administração a pacientes que estão usando qualquer forma de nitrato orgânico é contraindicada. É contra indicado para homens com problemas cardiovasculares e com restrição de atividade sexual. Não deve ser usada em pacientes com conhecida hipersensibilidade ao Tadalafil ou a qualquer componente da formulação. O uso de Tadalafil não é indicado para mulheres. Pacientes com insuficiência renal crônica, insuficiência hepática severa e diabéticos, devem fazer uso com acompanhamento médico. Evite a automedicação. Produtos, mesmo livres de obrigação de prescrição médica, merecem cuidado. As indicações postas não se tratam de propaganda, e sim de descrição do produto. Pessoas com hipersensibilidade à substância não devem fazer uso do produto. Em caso de hipersensibilidade ao produto, recomenda-se descontinuar o uso e consultar o médico. Imagens meramente ilustrativas. Não use o produto com o prazo de validade vencido. Manter em temperatura ambiente (15 a 30ºC). Proteger da luz, do calor e da umidade. Nestas condições, o produto se manterá próprio para o consumo, respeitando o prazo de validade indicado na embalagem. Manter fora do alcance das crianças. Nunca compre medicamentos sem orientação de um profissional habilitado. Este produto não deve ser utilizado por mulheres grávidas sem orientação médica. Siga corretamente o modo de usar. Não desaparecendo os sintomas, procure orientação médica. O uso do produto durante o período de amamentação também não é recomendado. Este produto não deve ser utilizado por menores de 18 anos sem orientação médica. "SE PERSISTIREM OS SINTOMAS, O MÉDICO DEVERÁ SER CONSULTADO" Os resultados e indicações referentes ao uso desse produto foram avaliados e comprovados pelo fabricante deste insumo farmacêutico. Não garantimos os resultados descritos, estes variam de pessoa para pessoa dependendo de diversos fatores como alimentação, prática de exercícios físicos, presença de outras patologias, bem como, o uso correto do produto conforme descrito na posologia."' ]
  },
  {
    code: 24,
    id: '37af83d2-24ac-454b-b3ef-68465f2a6e75',
    name: 'Tadalaspray',
    path: 'Tadalaspray',
    showCart: true,
    hidePriceCart: false,
    value: 329.9,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: true,
    prescriptionLink: prescriptionType.ed,
    image: '/assets/img/cart-images/tadalaspray-fundo-produto.png',
    images: [
      '/assets/img/cart-images/tadalaspray-fundo-produto.png',
    ],
    justMen:
    {
      img: '/assets/img/product-page-info/male.png',
    },
    slug: 'new-tadala-spray',
    numericSlug: undefined,
    rating: '5.0',
    carouselImages: [
      {
        banner: '/assets/img/product-page-carousel/tadala-1.jpg',
        mini: '/assets/img/product-page-carousel/mini-tadala-1.png',
      },
      {
        banner: '/assets/img/product-page-carousel/tadala-2.jpg',
        mini: '/assets/img/product-page-carousel/mini-tadala-2.png',
      },
      {
        banner: '/assets/img/product-page-carousel/tadala-3.jpg',
        mini: '/assets/img/product-page-carousel/mini-tadala-3.png',
      },
    ],
    advantages: [
      {
        icon: '/assets/img/product-page-advantages/tadala-1.png',
        text: 'Ativos originais e puros',
      },
      {
        icon: '/assets/img/product-page-advantages/tadala-2.png',
        text: 'Prático, em spray. Cabe no bolso.',
      },
      {
        icon: '/assets/img/product-page-advantages/tadala-3.png',
        text: 'Rápida Absorção',
      },
      {
        icon: '/assets/img/product-page-advantages/tadala-4.png',
        text: 'Encurta o intervalo de ereção',
      },
    ],
    commonQuestions: {
      banner: '/assets/img/product-page-questions/tadala.png',
      bannerMobile: '/assets/img/product-page-questions/tadala-mobile.png',
      questions: [
        {
          name: 'O que é?',
          description: 'Inovação no mercado sexual, é um spray potente, compacto e discreto tendo como ativo principal um dos mais recomendados no mundo por urologistas.',
        },
        {
          name: 'Como age?',
          description: 'Ao borrifa-lo embaixo da língua (sublingual), é instantaneamente absorvido pelo corpo, vasodilatando as artérias, aumentando o fluxo sanguíneo, auxiliando na promoção  de maior desejo e ereções mais duradouras.',
        },
        {
          name: 'O que esperar?',
          description: 'Aumento do desejo sexual, diminuição do período refratário (tempo de recuperação entre uma ejaculação e outra) e ereções mais vigorosas, apenas quando houver estimulo, e pelo período de 36h.',
        },
      ],
    },
    productInfo: {
      type: 'SAÚDE SEXUAL',
      unity: '10ml',
      duration: '5 MESES',
      hideUnity: true,
      hideLabel: false,
      text: [ 'Spray sexual que auxilia na performance e na evolução da ereção.<br />Duração estimada: <b>5 meses</b><br /> Local de aplicação: <b>Sublingual</b><br />Um frasco contém 120 doses de 5mg, totalizando 600mg de tadalafila (cialis)' ],
      subText: 'Venda sob <b>prescrição médica</b> <a href="https://blog.themens.com.br/outros/registros-aprovacoes-e-eficacia/"><u>Aprovações.<u/></a>',
      img: '/assets/img/product-page-info/tadala.png',
    },
    about: [
      {
        image: '/assets/img/product-page-about/tadala-1.jpg',
        title: 'Discreto',
        text: 'Com design digno das feiras em milão, cabe no bolso, gostoso ao toque e com sabor incrível. Você leva quando e onde quiser sem questionamentos.'
      },
      {
        image: '/assets/img/product-page-about/tadala-2.jpg',
        title: 'Inovador',
        text: 'Com absorção mais rápida que as pílulas, por ser sublingual, a biodisponibilidade tende a ser maior, potencializando os efeitos.'
      },
      {
        image: '/assets/img/product-page-about/tadala-3.jpg',
        title: 'Único',
        text: 'Com formula exclusiva e desenvolvimento proprietário, é diferente de tudo que já viu, e ainda tem um ótimo custo benefício.'
      },
    ],
    faq: [
      {
        title: 'Posso usar todos os dias? ',
        description: 'Deve-se utilizar de acordo com a prescrição médica. Normalmente, prescreve-se 1 borrifada (5mg) ao dia para tratamentos de incontinência urinária e 4 borrifadas (20mg) para uso sexual',
      },
      {
        title: 'O que acontece se eu exceder a dosagem?',
        description: 'Não é recomendado o uso acima do que foi prescrito. Deite, tome água e procure ajuda médica.',
      },
      {
        title: 'Quem não deve tomar?',
        description: 'Pessoas com questões cardíacas, hipertensas ou que já fizeram uso de tadalafila e não surtiu efeito/tiveram alergia.',
      },
      {
        title: 'O que tem no Tadalaspray?',
        description: 'Tadalaspray é um spray único e inovador contendo um dos ativos mais recomendados pelos médicos para o tratamento da diminuição de desejo e disfunção sexual.',
      },
      {
        title: 'Mulher pode utilizar?',
        description: 'O uso não é recomendado para o sexo biológico feminino. Não há comprovação de aumento de desejo sexual com seu uso, apenas vasodilatação.',
      },
      {
        title: 'Quais são os efeitos colaterais?',
        description: 'Aumento dos batimentos cardíacos, rubor facial, dores de cabeça, dores no corpo poderão ser um dos efeitos colaterais indesejáveis ao utilizar dosagens acima da prescrição.',
      },
      {
        title: 'Vou ficar ereto sempre?',
        description: 'Após utilizar o spray, você ficará ereto apenas se houver estímulo sexual, sendo seguro o uso anterior ao ato sem constrangimento.',
      },
      {
        title: 'Quanto tempo demora para fazer efeito?',
        description: 'Cerca de 30 min após sua utilização, você já conseguirá obter todos os benefícios.',
      },
    ],
    howWorks: {
      title: 'Como o Tadalafila (Cialis) funciona?',
      img: '/assets/img/product-page-carousel/tadala-works.png',
      imgMobile: '/assets/img/product-page-carousel/tadala-works-mobile.png',
    },
    howWorksInfo: [
      {
        title: 'Comunidade Médica',
        text: 'Considerado pelos médicos como um tratamento de primeira linha para solucionar a disfunção erétil, é considerada uma opção muito mais duradoura, eficiente e segura do que o Viagra.',
      },
      {
        title: 'Fluxo sanguíneo',
        text: 'Ao ser absorvida no corpo, inibe a proteína fosfodiesterase tipo 5, aumentando a quantidade de GMPC Cíclico, prolongando as ereções e diminuindo o tempo necessário para ficar ereto novamente',
      },
      {
        title: 'Estimulo sexual',
        text: 'Ela age apenas com estímulo sexual, ou seja, sem o devido estímulo não há ereção involuntária. Assim, não gera constrangimento e aumenta a confiança.',
      }
    ],
  },
  {
    code: 26,
    id: '0ed54cc2-f90d-4630-8362-e87c95a3d82d',
    tinyId: 'F10009',
    name: 'Combo Sleep Gummy',
    isCombo: true,
    showCart: true,
    hidePriceCart: false,
    value: 254.9,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionLink: prescriptionType.sleep,
    prescriptionRequired: true,
    rating: '4.8',
    image: '/assets/img/cart-images/sleep-gummy-fundo-produto-2.jpg',
    slug: 'sleep-gummy',
    numericSlug: '80293849093423',
    slugToUse: 'numericSlug',
    advantagesHeader: 'Existem muitos benefícios de ter um sono regulado, os principais são³:',
    description: {
      title: 'O que é\nSleep Gummy?',
      text: 'A Gummy é um medicamento, feito à base de gelatina zero açúcar, com 99.3% grau de pureza de melatonina. Produzido naturalmente pelo nosso organismo, a melatonina possuí como principal função regular o relógio biológico, fazendo com que funcione normalmente. Além disso, a melatonina promove o bom funcionamento do organismo e atua como antioxidante, além de diminuir crises de enxaqueca. \n',
    },
    images: [
      '/assets/img/products-images/the-mens-sleep-gummy-2.png',
      '/assets/img/products-images/the-mens-sleep-gummy-1.png',
      '/assets/img/cart-images/sleep-gummy-fundo-produto-2.jpg',
    ],
  },
  {
    code: 27,
    id: '445c28f3-d0b6-47ff-83d8-29bbf0e42be6',
    name: 'Tadalaspray',
    path: 'Tadalaspray',
    showCart: true,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    prescriptionLink: prescriptionType.ed,
    image: '/assets/img/cart-images/tadalaspray-fundo-produto.png',
    images: [
      '/assets/img/cart-images/tadalaspray-fundo-produto.png',
    ],
  },
  {
    code: 28,
    id: '685e18a9-cc21-461e-a63e-ded331978111',
    name: 'Tadalaspray',
    path: 'Tadalaspray',
    discountPercent: '',
    showCart: true,
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    prescriptionLink: prescriptionType.ed,
    image: '/assets/img/cart-images/tadalaspray-fundo-produto.png',
    images: [
      '/assets/img/cart-images/tadalaspray-fundo-produto.png',
    ],
  },

  //Products used in the checkout promotion:
  {
    code: 29,
    id: 'a30aaa91-a03f-4f16-aa76-2a6f17788e0c',
    name: 'Tadalaspray',
    path: 'Tadalaspray',
    value: 174.9,
    showCart: true,
    tag: '2ª unidade com 30% OFF',
    isPromotionalProduct: true,
    productWithoutPromotionId: '312974bf-1dac-434d-8084-942e42beed8b',
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    prescriptionLink: prescriptionType.ed,
    image: '/assets/img/cart-images/tadalaspray-fundo-produto-promo.png',
    images: [
      '/assets/img/cart-images/tadalaspray-fundo-produto-promo.png',
    ],
  },
  {
    code: 30,
    id: '453fe441-1d18-4907-b2af-0af92d1261ae',
    name: 'Sleep Gummy',
    path: 'Sleep Gummy',
    value: 79.90,
    showCart: true,
    hidePriceCart: false,
    tag: '2ª unidade com 20% OFF',
    isPromotionalProduct: true,
    productWithoutPromotionId: 'e743ec60-df88-4f4b-ac84-748be2473d2b',
    tagPromotion: 'Promoção',
    discountPercent: '20',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    prescriptionLink: prescriptionType.ed,
    image: '/assets/img/cart-images/sleep-gummy-fundo-produto-promo.png',
    images: [
      '/assets/img/cart-images/sleep-gummy-fundo-produto-promo.png',
    ],
  },
  {
    code: 31,
    id: '84c34b6d-53a3-4da5-9395-0f041b4e0058',
    name: 'Vita Gummy',
    showCart: true,
    hidePriceCart: false,
    path: 'Vita Gummy',
    value: 46.41,
    tag: '2ª unidade com 30% OFF',
    tagPromotion: 'Promoção',
    isPromotionalProduct: true,
    productWithoutPromotionId: '2ad58d0e-5934-4f1a-9d51-8cba378122b6',
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    prescriptionLink: prescriptionType.ed,
    image: '/assets/img/cart-images/vita-gummy-fundo-produto-promo.png',
    images: [
      '/assets/img/cart-images/vita-gummy-fundo-produto-promo.png',
    ],
  },
  {
    code: 37,
    id: '08e64b5d-cf21-4a22-8742-c1c5d69b9f63',
    name: 'Vita Gummy',
    hideQtd: false,
    signature: true,
    oldValue: null,
    showCart: false,
    hidePriceCart: false,
    value: 22.90,
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    image: '/assets/img/cart-images/chocosono-2caixas-fundo-produto.jpg',
    description: {
      title: 'Vita Gummy',
      text: 'Vita Gummy - 1 caixa.',
    },
    amounts: [],
    infos: {},
    faq: [],
  },
  {
    code: 32,
    id: 'af31e13e-7c4d-470d-9d68-f69d0d2d6b7b',
    name: 'Shampoo Energizante',
    path: 'Shampoo Energizante',
    value: 31.43,
    showCart: true,
    hidePriceCart: false,
    tag: '2ª unidade com 30% OFF',
    tagPromotion: 'Promoção',
    isPromotionalProduct: true,
    productWithoutPromotionId: 'e6c99cac-19cf-4f18-8704-0fff17dbb133',
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    prescriptionLink: prescriptionType.ed,
    image: '/assets/img/cart-images/shampoo-fundo-produto-promo.png',
    images: [
      '/assets/img/cart-images/shampoo-fundo-produto-promo.png',
    ],
  },
  {
    code: 33,
    id: '8719d8f8-880a-44f6-921b-dbe1a761b5e0',
    name: 'Minoxidil base em espuma',
    path: 'Minoxidil base em espuma',
    value: 45.43,
    showCart: true,
    hidePriceCart: false,
    tag: '2ª unidade com 30% OFF',
    tagPromotion: 'Promoção',
    isPromotionalProduct: true,
    productWithoutPromotionId: '6f9919da-d5cc-4948-88ae-5160852cb7b7',
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    prescriptionLink: prescriptionType.ed,
    image: '/assets/img/cart-images/minoxidil-fundo-produto-promo.png',
    images: [
      '/assets/img/cart-images/minoxidil-fundo-produto-promo.png',
    ],
  },
  {
    code: 34,
    id: '4dc2cf31-2f99-4526-8963-6889e2d24fad',
    name: 'Finasterida',
    path: 'Finasterida',
    value: 20.23,
    showCart: true,
    hidePriceCart: false,
    tag: '2ª unidade com 30% OFF',
    tagPromotion: 'Promoção',
    isPromotionalProduct: true,
    productWithoutPromotionId: '40c5747d-1b87-4768-a3aa-c1186a9e3b1f',
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    prescriptionLink: prescriptionType.ed,
    image: '/assets/img/cart-images/finasterida-fundo-produto-promo.png',
    images: [
      '/assets/img/cart-images/finasterida-fundo-produto-promo.png',
    ],
  },
  {
    code: 35,
    id: '0ea626a1-159d-46d8-a09d-acd529d0a1c5',
    name: 'Tônico para barba',
    path: 'Tônico para barba',
    value: 45.43,
    showCart: true,
    hidePriceCart: false,
    tag: '2ª unidade com 30% OFF',
    tagPromotion: 'Promoção',
    isPromotionalProduct: true,
    productWithoutPromotionId: 'fbd7397f-8071-4f0a-9a64-90debfbf908a',
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    prescriptionLink: prescriptionType.ed,
    image: '/assets/img/cart-images/tonico-fundo-produto-promo.png',
    images: [
      '/assets/img/cart-images/tonico-fundo-produto-promo.png',
    ],
  },
  {
    code: 36,
    id: '0d75185a-7e0a-4279-976b-cb32b0451e3d',
    name: 'Anti-aging 10% nano VIT C',
    path: 'Anti-aging 10% nano VIT C',
    value: 132.93,
    showCart: true,
    hidePriceCart: false,
    tag: '2ª unidade com 30% OFF',
    tagPromotion: 'Promoção',
    isPromotionalProduct: true,
    productWithoutPromotionId: '8cc5dd9a-732f-45cb-bfd1-2dbdbd462719',
    discountPercent: '',
    category: ProductCategory.HEALTH,
    prescriptionRequired: false,
    prescriptionLink: prescriptionType.ed,
    image: '/assets/img/cart-images/anti-aging-fundo-produto-promo.png',
    images: [
      '/assets/img/cart-images/anti-aging-fundo-produto-promo.png',
    ],
  },
  {
    code: 38,
    id: '29609206-a390-4b73-8213-8464c4c4ea4a',
    tinyId: 'CREA0001',
    name: 'Creatina 500g 100% Pura',
    path: 'Creatina 500g 100% Pura',
    showCart: true,
    hidePriceCart: false,
    value: 189.90,
    category: ProductCategory.HEALTH,
    image: '/assets/img/cart-images/creatina-carrinho.jpg',
    images: [
      '/assets/img/cart-images/creatina-carrinho.jpg',
    ],
    slug: 'creatina',
    numericSlug: undefined,
  },
  {
    code: 39,
    id: '297f6419-ec90-4e9f-aac3-29c9dc6abbfc',
    name: 'Creatina 500g 100% Pura',
    path: 'Creatina 500g 100% Pura',
    showCart: true,
    hidePriceCart: false,
    oldValue: 189.90,
    value: 129.90,
    tag: '2ª unidade com 30% OFF',
    tagPromotion: 'Promoção',
    isPromotionalProduct: true,
    productWithoutPromotionId: '29609206-a390-4b73-8213-8464c4c4ea4a',
    discountPercent: 30,
    category: ProductCategory.HEALTH,
    image: '/assets/img/cart-images/creatina-carrinho.jpg',
    images: [
      '/assets/img/cart-images/creatina-carrinho.jpg',
    ],
    slug: 'creatina',
    numericSlug: undefined,
  },
];

export const promotionProducts = {
  TADALA: {
    name: 'Tadalaspray',
    color: 'promotion-card-checkout__title--tadalaspray',
    shadowColor: 'promotion-card-checkout__button--tadalaspray',
    backgroundColor: 'promotion-card-checkout-mobile__background--tadalaspray',
    promotionProductID: 'a30aaa91-a03f-4f16-aa76-2a6f17788e0c',
    id: '312974bf-1dac-434d-8084-942e42beed8b',
  },
  SLEEP_GUMMY: {
    name: 'Sleep Gummy',
    color: 'promotion-card-checkout__title--sleep-gummy',
    shadowColor: 'promotion-card-checkout__button--sleep-gummy',
    backgroundColor: 'promotion-card-checkout-mobile__background--sleep-gummy',
    promotionProductID: '453fe441-1d18-4907-b2af-0af92d1261ae',
    id: 'e743ec60-df88-4f4b-ac84-748be2473d2b',
  },
  VITA_GUMMY: {
    name: 'Vita Gummy',
    color: 'promotion-card-checkout__title--vita-gummy',
    shadowColor: 'promotion-card-checkout__button--vita-gummy',
    backgroundColor: 'promotion-card-checkout-mobile__background--vita-gummy',
    promotionProductID: '84c34b6d-53a3-4da5-9395-0f041b4e0058',
    id: '2ad58d0e-5934-4f1a-9d51-8cba378122b6',
  },
  SHAMPOO: {
    name: 'Shampoo',
    color: 'promotion-card-checkout__title--shampoo',
    shadowColor: 'promotion-card-checkout__button--shampoo',
    backgroundColor: 'promotion-card-checkout-mobile__background--shampoo',
    promotionProductID: 'af31e13e-7c4d-470d-9d68-f69d0d2d6b7b',
    id: 'e6c99cac-19cf-4f18-8704-0fff17dbb133',
  },
  MINOXIDIL: {
    name: 'Minoxidil',
    color: 'promotion-card-checkout__title--minoxidil',
    shadowColor: 'promotion-card-checkout__button--minoxidil',
    backgroundColor: 'promotion-card-checkout-mobile__background--minoxidil',
    promotionProductID: '8719d8f8-880a-44f6-921b-dbe1a761b5e0',
    id: '6f9919da-d5cc-4948-88ae-5160852cb7b7',
  },
  FINASTERIDA: {
    name: 'Finasterida',
    color: 'promotion-card-checkout__title--finasterida',
    shadowColor: 'promotion-card-checkout__button--finasterida',
    backgroundColor: 'promotion-card-checkout-mobile__background--finasterida',
    promotionProductID: '4dc2cf31-2f99-4526-8963-6889e2d24fad',
    id: '40c5747d-1b87-4768-a3aa-c1186a9e3b1f',
  },
  TONICO_BARBA: {
    name: 'Tonico para barba',
    color: 'promotion-card-checkout__title--tonico',
    shadowColor: 'promotion-card-checkout__button--tonico',
    backgroundColor: 'promotion-card-checkout-mobile__background--tonico',
    promotionProductID: '0ea626a1-159d-46d8-a09d-acd529d0a1c5',
    id: 'fbd7397f-8071-4f0a-9a64-90debfbf908a',
  },
  ANTI_AGING: {
    name: 'Anti-aging',
    color: 'promotion-card-checkout__title--anti-aging',
    shadowColor: 'promotion-card-checkout__button--anti-aging',
    backgroundColor: 'promotion-card-checkout-mobile__background--anti-aging',
    promotionProductID: '0d75185a-7e0a-4279-976b-cb32b0451e3d',
    id: '8cc5dd9a-732f-45cb-bfd1-2dbdbd462719',
  },
  CREATINA: {
    name: 'Creatina',
    color: 'promotion-card-checkout__title--creatina',
    shadowColor: 'promotion-card-checkout__button--creatina',
    backgroundColor: 'promotion-card-checkout-mobile__background--creatina',
    promotionProductID: '297f6419-ec90-4e9f-aac3-29c9dc6abbfc',
    id: '29609206-a390-4b73-8213-8464c4c4ea4a',
  },
};

export function getProductById (id) {
  let response = products.find((o) => o.id === id);

  if (!response) {
    const variants = products
      .filter((o) => o.hasVariant).map(o => o.hasVariant)
      .reduce((result, { variants = [] }) => result
        .concat(variants.filter(o => o.id === id)), []);
    response = variants.find(variant => variant.id === id);
  }

  if (response && !response.quantity) {
    response.quantity = 1;
  }

  return response;
}

export function getProductByCode (code) {
  return products.find((o) => o.code === code);
}

export function getProductBySlug (slug) {
  return products.find((o) => o.slug === slug || o.numericSlug === slug);
}

export function getAllProducts () {
  return products;
}

export function getProductsByCategory (category, withQuantity) {
  let response = products.filter((o) => o.category === category);

  if (withQuantity) {
    response = response.map((o) => ({ ...o, quantity: 1 }));
  }

  return response;
}

export function hasChocosono (productsInCart) {
  let chocosonoProducts = products.filter((o) => o.slug === 'chocosono');
  chocosonoProducts = chocosonoProducts.map((o) => o.id);

  productsInCart = productsInCart.map((o) => o.id);

  chocosonoProducts = chocosonoProducts.filter((o) => {
    if (productsInCart.includes(o)) return o;
  });

  return chocosonoProducts && chocosonoProducts.length > 0;
}

export function hasCombo (productsInCart) {
  let productIsACombo = products.filter((o) => o.isCombo === true);
  productIsACombo = productIsACombo.map((o) => o.id);

  productsInCart = productsInCart.map((o) => o.id);

  productIsACombo = productIsACombo.filter((o) => {
    if (productsInCart.includes(o)) return o;
  });

  return productIsACombo;
}

export function isPromotionalProduct (id) {
  const promotional = products.filter((o) => id === o.id && o.isPromotionalProduct);
  return promotional && promotional.length > 0;
}

export function getTransactionsItems (transactionItems, identifier) {
  const item = transactionItems.find(
    (item) => item.identifier === identifier
  );

  return !!item;
}

